/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A slightly refined version of RFC-3339 compliant DateTime Scalar */
  DateTime: { input: string; output: string; }
  /** Represents a date, ignoring timezone */
  LocalDate: { input: string; output: string; }
  /** Civil date/time in the format yyyy-MM-dd'T'HH:mm:ss.SSS */
  LocalDateTime: { input: string; output: string; }
  /** 24-hour clock time value string in the format `hh:mm:ss` or `hh:mm:ss.sss`. */
  LocalTime: { input: any; output: any; }
  /**
   * Represents a date and time with explicit timezone information
   * Ex: An RFC-3339 compliant date time scalar that accepts string
   * values like 1996-12-19T16:39:57-08:00
   * See https://github.com/graphql-java/graphql-java-extended-scalars?tab=readme-ov-file#date--time-scalars
   */
  OffsetDateTime: { input: any; output: any; }
  /** A universally unique identifier compliant UUID Scalar */
  UUID: { input: any; output: any; }
};

export type ActivityDefaultPayload = {
  __typename?: 'ActivityDefaultPayload';
  keywords: Array<Maybe<Scalars['String']['output']>>;
  targetActionCount: Scalars['Int']['output'];
};

export type ActivityLevel = {
  __typename?: 'ActivityLevel';
  /** Factor (numeric multiplier) associated with the Activity level */
  activityLevelFactor: Scalars['Float']['output'];
  /** Current activity level */
  activityLevelName: ActivityLevelName;
};

/** ActivityLevel is an enum of available options for the Activity level */
export enum ActivityLevelName {
  Dynamic = 'DYNAMIC',
  SomewhatActive = 'SOMEWHAT_ACTIVE',
  VeryActive = 'VERY_ACTIVE'
}

export type AggregatedBloodGlucoseData = {
  __typename?: 'AggregatedBloodGlucoseData';
  /**
   *  Total number of glucose level measurements in
   *  the aggregation (considering duplicates)
   */
  glucoseLevelsCount: Scalars['Int']['output'];
  /**
   *  Range statistics used in the aggregation to define what is
   *  considered normal
   */
  normalRangeStatistics: AggregatedBloodGlucoseRangeStatisticsData;
  /**
   *  The distinct list of glucose level (in mg/dL) measurements
   *  considered in the aggregation. Only one entry is added for
   *  multiple occurrences of the same glucose level. For example,
   *  in a daily aggregation, if two glucose measurements of '130'
   *  are recorded, only one '130' will be included in the list
   */
  uniqueGlucoseLevelsMgDl: Array<Scalars['Int']['output']>;
};

export type AggregatedBloodGlucoseRangeStatisticsData = {
  __typename?: 'AggregatedBloodGlucoseRangeStatisticsData';
  /**
   *  Total percentage (0-100) of glucose level (in mg/dL)
   *  measurements within the range across the aggregation
   *  period
   */
  percentageInRange: Scalars['Float']['output'];
  /**
   *  The glucose level (in mg/dL) range used to calculate
   *  the percentage
   */
  rangeMgDl: BloodGlucoseRangeData;
};

export type AggregatedLessonsData = {
  __typename?: 'AggregatedLessonsData';
  sumLessonsCompleted: Scalars['Int']['output'];
  sumSecondsRead: Scalars['Int']['output'];
};

export type AggregatedMealData = {
  __typename?: 'AggregatedMealData';
  sumCalories: Scalars['Float']['output'];
  sumCarbohydrateMg: Scalars['Float']['output'];
  sumDietaryFiberMg: Scalars['Float']['output'];
  sumGreenCalories: Scalars['Float']['output'];
  sumOrangeCalories: Scalars['Float']['output'];
  sumOtherCalories: Scalars['Float']['output'];
  sumPotassiumMg: Scalars['Float']['output'];
  sumProteinMg: Scalars['Float']['output'];
  sumSodiumMg: Scalars['Float']['output'];
  sumTotalFatMg: Scalars['Float']['output'];
  sumYellowCalories: Scalars['Float']['output'];
};

export type AggregatedMeasurementData = {
  __typename?: 'AggregatedMeasurementData';
  aggregatedMeasurementDataOneOf: AggregatedMeasurementDataOneOf;
  beginningTimeOfAggregation: Scalars['LocalDateTime']['output'];
  endTimeOfAggregation: Scalars['LocalDateTime']['output'];
};

export type AggregatedMeasurementDataList = {
  __typename?: 'AggregatedMeasurementDataList';
  aggregatedMeasurements: Array<AggregatedMeasurementData>;
};

export type AggregatedMeasurementDataOneOf = {
  __typename?: 'AggregatedMeasurementDataOneOf';
  aggregatedBloodGlucoseData?: Maybe<AggregatedBloodGlucoseData>;
  aggregatedLessonsData?: Maybe<AggregatedLessonsData>;
  aggregatedMealData?: Maybe<AggregatedMealData>;
  aggregatedMedicationData?: Maybe<AggregatedMedicationsData>;
  aggregatedMoodData?: Maybe<AggregatedMoodData>;
  aggregatedStepsData?: Maybe<AggregatedStepsData>;
  aggregatedWaterData?: Maybe<AggregatedWaterData>;
  aggregatedWeightData?: Maybe<AggregatedWeightData>;
};

export type AggregatedMedicationData = {
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
};

export type AggregatedMedicationGData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationGData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseG: Scalars['Float']['output'];
};

export type AggregatedMedicationMcgData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationMcgData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseMcg: Scalars['Float']['output'];
};

export type AggregatedMedicationMgData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationMgData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseMg: Scalars['Float']['output'];
};

export type AggregatedMedicationMlData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationMlData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseMl: Scalars['Float']['output'];
};

export type AggregatedMedicationPercentData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationPercentData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDosePercent: Scalars['Float']['output'];
};

export type AggregatedMedicationsData = {
  __typename?: 'AggregatedMedicationsData';
  medications: Array<AggregatedMedicationData>;
};

export type AggregatedMoodData = {
  __typename?: 'AggregatedMoodData';
  averageMoodLevel: Scalars['Float']['output'];
};

export type AggregatedStepsData = {
  __typename?: 'AggregatedStepsData';
  sumSteps: Scalars['Int']['output'];
};

export type AggregatedWaterData = {
  __typename?: 'AggregatedWaterData';
  sumWaterLiters: Scalars['Float']['output'];
};

export type AggregatedWeightData = {
  __typename?: 'AggregatedWeightData';
  averageWeightLevel: Scalars['Float']['output'];
};

/** AI generated insight based on user activity. */
export type AiInsight = {
  __typename?: 'AiInsight';
  /** Suggested quick replies. */
  actions: Array<InsightCallToAction>;
  /** CTA header */
  ctaHeader?: Maybe<Scalars['String']['output']>;
  /** The user feedback for the insight */
  feedback?: Maybe<InsightFeedback>;
  /** Unique ID of the insight. */
  id: Scalars['ID']['output'];
  /** Text message that contains the main insight. If null, that means nothing was generated by ML. */
  insight?: Maybe<Scalars['String']['output']>;
  /** Subtitle to show to the user for the insight */
  insightSubtitle: Scalars['String']['output'];
  /** Title to show to the user for the insight */
  insightTitle: Scalars['String']['output'];
  /** Welli profile image URL. Excluding Welli from the name on purpose since the name is changeable. */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

/** AI generated meal insight based on a user's meal log. */
export type AiMealInsight = {
  __typename?: 'AiMealInsight';
  /** Suggested quick replies. */
  actions: Array<InsightCallToAction>;
  /** CTA header */
  ctaHeader?: Maybe<Scalars['String']['output']>;
  /** The user feedback for the insight */
  feedback?: Maybe<InsightFeedback>;
  /** Unique ID of the meal insight. */
  id: Scalars['ID']['output'];
  /** Text message that contains an insight into the meal. If null, that means nothing was generated. */
  insight?: Maybe<Scalars['String']['output']>;
  /** Subtitle to show to the user for the insight */
  insightSubtitle: Scalars['String']['output'];
  /** Title to show to the user for the insight */
  insightTitle: Scalars['String']['output'];
  /** Welli profile image URL. Excluding Welli from the name on purpose since the name is changeable. */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

/** Name value pair that marks an analytics property and it's value, to be used in an analytics properties list */
export type AnalyticsProperty = {
  __typename?: 'AnalyticsProperty';
  /** Analytics property name */
  name: Scalars['String']['output'];
  /** Analytics property value */
  value: Scalars['String']['output'];
};

export type AnnotatedMeasurementTrendChart = {
  __typename?: 'AnnotatedMeasurementTrendChart';
  entries: Array<TrendChartEntry>;
  xAxis: LocalDateTimeRange;
  yAxis: FloatRange;
};

export type AnuraConfiguration = {
  __typename?: 'AnuraConfiguration';
  /** UUID generated to be used as an identifier for a user in Anura */
  partnerId: Scalars['UUID']['output'];
  /** Study identifier, study is a set of measurements to be taken for specific scan */
  studyId: Scalars['String']['output'];
};

export type AnuraTokenInput = {
  /** Mobile application name */
  appName: Scalars['String']['input'];
  /** Mobile application version */
  appVersion: Scalars['String']['input'];
  /** Bundle identifier (e.g. DFX Client) */
  bundleIdentifier: Scalars['String']['input'];
  /** Client platform */
  platform: TargetPlatform;
};

/** Art Break content for creative mindfulness tasks. */
export type ArtBreaksContent = {
  __typename?: 'ArtBreaksContent';
  /** Text to overlay on top of the hero image, e.g. 'Mountain majesty' */
  galleryTitle?: Maybe<Scalars['String']['output']>;
  /** Cover image URL for the art break UI */
  primaryImageUrl?: Maybe<Scalars['String']['output']>;
  /** Image URL for completion state */
  secondaryImageUrl?: Maybe<Scalars['String']['output']>;
};

export type ArticleAssignment = {
  __typename?: 'ArticleAssignment';
  articleDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  articleTriggers: Array<Maybe<ArticleTrigger>>;
  audioResource?: Maybe<AudioResource>;
  contentId: Scalars['String']['output'];
  contentUrl: Scalars['String']['output'];
  feedbackText: Scalars['String']['output'];
  hideMenuButton?: Maybe<Scalars['Boolean']['output']>;
  moduleId?: Maybe<Scalars['String']['output']>;
  repeatable?: Maybe<Scalars['Boolean']['output']>;
  targetPlatform?: Maybe<TargetPlatform>;
  title: Scalars['String']['output'];
  titleCompleted?: Maybe<Scalars['String']['output']>;
};

export enum ArticleTrigger {
  Autoopen = 'AUTOOPEN',
  BrainDump = 'BRAIN_DUMP',
  ColorSystem = 'COLOR_SYSTEM',
  CreatePositiveExperiences = 'CREATE_POSITIVE_EXPERIENCES',
  CreateSpace = 'CREATE_SPACE',
  DefuseThoughts = 'DEFUSE_THOUGHTS',
  FeelFeelings = 'FEEL_FEELINGS',
  FreeFeelings = 'FREE_FEELINGS',
  Gametime = 'GAMETIME',
  GenerateTasks = 'GENERATE_TASKS',
  GetGrounded = 'GET_GROUNDED',
  GratitudeRemix = 'GRATITUDE_REMIX',
  GuidedBreathing = 'GUIDED_BREATHING',
  HideFromCurriculum = 'HIDE_FROM_CURRICULUM',
  Intro = 'INTRO',
  MeetYourGroup = 'MEET_YOUR_GROUP',
  Move = 'MOVE',
  NoomCoinIntro = 'NOOM_COIN_INTRO',
  Practice = 'PRACTICE',
  PromptToContinueOrStop = 'PROMPT_TO_CONTINUE_OR_STOP',
  Reframe = 'REFRAME',
  RefreshProgramProgress = 'REFRESH_PROGRAM_PROGRESS',
  Retro = 'RETRO',
  RideWaves = 'RIDE_WAVES',
  SelfCompassionBreak = 'SELF_COMPASSION_BREAK',
  SetUp = 'SET_UP',
  SharpenToolkit = 'SHARPEN_TOOLKIT',
  ShowInMyLibrary = 'SHOW_IN_MY_LIBRARY',
  Sleep = 'SLEEP',
  Soothe = 'SOOTHE',
  Tool = 'TOOL',
  UnlockFoodLogging = 'UNLOCK_FOOD_LOGGING',
  WaterGoal = 'WATER_GOAL',
  WaterLoggingIntro = 'WATER_LOGGING_INTRO',
  WeightLossZoneIntro = 'WEIGHT_LOSS_ZONE_INTRO',
  WeighIn = 'WEIGH_IN',
  Welcome = 'WELCOME'
}

export type Assignment = ArticleAssignment | ContentSectionAssignment | StandaloneContentSectionAssignment | TrackerAssignment;

/**
 * Attribution data is used by any action with an external source. This data
 * model is a contracted version of the Attribution Data model in CoachServer,
 * with the difference being that here, we use a one-of to model polymorphism,
 * while there, a special `type` field is used.
 */
export type AttributionDataInput = {
  bodyTrace?: InputMaybe<BodyTraceAttributionDataInput>;
  googleFit?: InputMaybe<GoogleFitAttributionDataInput>;
  healthConnect?: InputMaybe<HealthConnectAttributionDataInput>;
  healthKit?: InputMaybe<HealthKitAttributionDataInput>;
  noom?: InputMaybe<NoomAppAttributionDataInput>;
  prismBodyScan?: InputMaybe<PrismBodyScanAttributionDataInput>;
  sHealth?: InputMaybe<SHealthAttributionDataInput>;
  validic?: InputMaybe<ValidicAttributionDataInput>;
  validicV2?: InputMaybe<ValidicV2AttributionDataInput>;
};

export type AudioResource = {
  __typename?: 'AudioResource';
  url: Scalars['String']['output'];
};

/**
 * Overview data broken down by day. Includes a distinct list of blood
 * glucose level readings (in mg/dL) for a specific day and the range
 * statistics used to calculate the percentage of blood glucose readings
 * within the normal range for that day
 */
export type BloodGlucoseDailyBreakdownData = {
  __typename?: 'BloodGlucoseDailyBreakdownData';
  /** The date to which this breakdown of overview data refers */
  breakdownDay: Scalars['LocalDate']['output'];
  /**
   * Statistics data used to define the percentage of blood glucose
   * level (in mg/dL) readings that fall within a range considered normal
   */
  normalRangeStatistics: BloodGlucoseRangeStatisticsData;
  /**
   * The distinct list of blood glucose level readings (in mg/dL). Only one
   * entry is added for multiple occurrences of the same blood glucose level.
   * For example, if two glucose measurements of '130' were recorded on a day,
   * only one '130' will be included in this list
   */
  uniqueGlucoseLevelsMgDl: Array<Scalars['Int']['output']>;
};

export type BloodGlucoseData = {
  __typename?: 'BloodGlucoseData';
  /**  Glucose level in mg/dL which is a numerical value between 0-800 */
  glucoseLevelMgDl: Scalars['Int']['output'];
  /**  Meal context when blood glucose measurement was taken */
  mealContext: MealContext;
  /**  date_time when blood glucose measurement was taken */
  measurementCivilDateTime: Scalars['LocalDateTime']['output'];
};

export type BloodGlucoseDataInput = {
  /**  Glucose level in mg/dL which is a numerical value between 0-800 */
  glucoseLevelMgDl: Scalars['Int']['input'];
  /**  Meal context when blood glucose measurement was taken */
  mealContext: MealContext;
  /**  date_time when blood glucose measurement was taken */
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
};

/**
 * The overview of a user's blood glucose data for a specified time period,
 * starting from a given date
 */
export type BloodGlucoseOverviewData = {
  __typename?: 'BloodGlucoseOverviewData';
  /**
   * A list of all blood glucose level readings (in mg/dL) along with their
   * respective measurement times for the specified period
   */
  completeGlucoseReadings?: Maybe<Array<Maybe<BloodGlucoseReadingData>>>;
  /**
   * Overview data broken down by day. Includes a distinct list of blood
   * glucose level readings (in mg/dL) for a specific day and the range
   * statistics used to calculate the percentage of blood glucose readings
   * within the normal range for that day
   */
  dailyBreakdown?: Maybe<Array<Maybe<BloodGlucoseDailyBreakdownData>>>;
  /** The end date for the period considered for the overview data */
  endDate: Scalars['LocalDate']['output'];
  /**
   * Statistics data used to define the percentage of blood glucose
   * level (in mg/dL) readings that fall within a range considered normal
   */
  normalRangeStatistics?: Maybe<BloodGlucoseRangeStatisticsData>;
  /** The period considered for the overview data */
  period: BloodGlucoseOverviewPeriod;
  /** The start date for the period considered for the overview data */
  startDate: Scalars['LocalDate']['output'];
};

/**
 * The possible periods that can be considered for the blood
 * glucose overview data
 */
export enum BloodGlucoseOverviewPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type BloodGlucoseRangeData = {
  __typename?: 'BloodGlucoseRangeData';
  /**  Lower bound of the range (inclusive) */
  lower: Scalars['Int']['output'];
  /**  Upper bound of the range (inclusive) */
  upper: Scalars['Int']['output'];
};

/**
 * Statistics data used to define the percentage of blood glucose
 * level (in mg/dL) readings that fall within a range considered normal
 */
export type BloodGlucoseRangeStatisticsData = {
  __typename?: 'BloodGlucoseRangeStatisticsData';
  /**
   * Total number of glucose measurements within the range
   * (optional for backwards compatibility)
   */
  countInRange?: Maybe<Scalars['Int']['output']>;
  /**
   * Total percentage (0-100) of glucose level (in mg/dL) measurements within
   * the range
   */
  percentageInRange: Scalars['Float']['output'];
  /** The glucose level (in mg/dL) range used to calculate the percentage */
  rangeMgDl: BloodGlucoseRangeData;
};

/** The data of a blood glucose reading */
export type BloodGlucoseReadingData = {
  __typename?: 'BloodGlucoseReadingData';
  /** The blood glucose level reading value (in mg/dL) */
  glucoseLevelsMgDl: Scalars['Int']['output'];
  /** The meal context the blood glucose level reading was measured */
  mealContext: MealContext;
  /** The date and time when the blood glucose level reading was measured */
  readingDateTime: Scalars['LocalDateTime']['output'];
};

/** Payload added to Blood Glucose Tracker Assignments */
export type BloodGlucoseTrackerPayload = {
  __typename?: 'BloodGlucoseTrackerPayload';
  /** Indicates whether the minimum number of glucose readings required for the task has been met */
  minGlucoseReadingsCountAchieved: Scalars['Boolean']['output'];
  /** Subtitle of the task card */
  subTitle: Scalars['String']['output'];
  /** Title of the task card */
  title: Scalars['String']['output'];
};

/** Response from a successfully deleted body scan */
export type BodyScanDeletionResponse = {
  __typename?: 'BodyScanDeletionResponse';
  /** Unique identifier for the scan that was deleted */
  scanUuid: Scalars['UUID']['output'];
};

export type BodyScanInfo = {
  __typename?: 'BodyScanInfo';
  /** Unique identifier for the body scan */
  scanUuid: Scalars['UUID']['output'];
  /** The current status for the body scan */
  status: BodyScanStatus;
};

/**
 * Indicates what data points (if any) need to be gathered from the user
 * when they enter the body scan flow
 */
export type BodyScanIngressChecks = {
  __typename?: 'BodyScanIngressChecks';
  /**
   * If we need to show additional screen to ask user for a review of a recently
   * made body scan video to ensure everything is ok (legs position, body
   * movement, etc.)
   */
  accuracyReviewRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If we don't already have this information recorded, prompt the user to
   * confirm their sex
   */
  assignedSexRequired: Scalars['Boolean']['output'];
  /**
   * If we don't already have the user's birth date in the system,
   * then prompt them to enter it
   */
  birthDateRequired: Scalars['Boolean']['output'];
  /**
   * If we don't already have this information recorded, prompt the user to
   * confirm body scan mode (one of NORMAL/ATHLETE)
   */
  bodyScanModeRequired: Scalars['Boolean']['output'];
  /**
   * If the user doesn't have a recent enough weigh-in then they need
   * to confirm their current weight before creating a new body scan
   */
  currentWeightRequired: Scalars['Boolean']['output'];
  /** First time body scan users need to confirm their goal weight */
  goalWeightRequired: Scalars['Boolean']['output'];
  /** Indicates whether the user has created a body scan before */
  isNewBodyScanUser: Scalars['Boolean']['output'];
  /**
   * If the user must accept (or re-accept, in the case of updated terms)
   * the privacy policy
   */
  termsAcceptanceRequired: Scalars['Boolean']['output'];
};

/** Encapsulates a list of body scans */
export type BodyScanList = Pageable & {
  __typename?: 'BodyScanList';
  /** The body scans */
  bodyScans: Array<BodyScanSummary>;
  /** Metadata for fetching the next page of body scan results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** Whether the avatar preview images should be rendered by default */
  showAvatars: Scalars['Boolean']['output'];
  /** The total number of body scans which match the filtering criteria for the returned list */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * A metric which was computed from a user's body scan. Fields declared using this type should
 * be named explicitly after the measurement (ex: massInKgMetric, fatPercentMetric)
 */
export type BodyScanMetric = {
  __typename?: 'BodyScanMetric';
  /**
   * Each metric has an associated label (ex: LOW/HIGH/etc), based on how the user's
   * measured value compares to their demographic. Only populated if the user's
   * demographic info is available
   */
  label?: Maybe<BodyScanMetricHealthLabel>;
  /** The actual measured value for the metric */
  value: Scalars['Float']['output'];
};

/**
 * Enumerates the qualitative tags that can be assigned to a health metric.
 * Ex: leanMass=HIGH, fatMass=IN_RANGE, etc.
 */
export enum BodyScanMetricHealthLabel {
  High = 'HIGH',
  InRange = 'IN_RANGE',
  Low = 'LOW',
  VeryHigh = 'VERY_HIGH',
  VeryLow = 'VERY_LOW'
}

export enum BodyScanMode {
  /** For users who have regular training */
  Athlete = 'ATHLETE',
  /** The default mode for users who do not have regular training */
  Normal = 'NORMAL'
}

/** Encapsulates the data for a body scan user settings */
export type BodyScanSettingsResponse = {
  __typename?: 'BodyScanSettingsResponse';
  mode?: Maybe<BodyScanMode>;
  showAvatar?: Maybe<Scalars['Boolean']['output']>;
};

export enum BodyScanStatus {
  /** Default status for a newly-created body scan record */
  AwaitingSubmission = 'AWAITING_SUBMISSION',
  /**
   * Indicates that Prism reported that the body scan processing job
   * has completed
   */
  ProcessingComplete = 'PROCESSING_COMPLETE',
  /**
   * Indicates that Prism reported that the body scan processing job
   * has failed
   */
  ProcessingFailed = 'PROCESSING_FAILED',
  /**
   * Indicates that Prism reported that the body scan processing job
   * has begun
   */
  ProcessingStarted = 'PROCESSING_STARTED',
  /**
   * The Noom backend has completed post-processing the Prism body scan
   * and the resulting Health Report is ready for the user to view
   */
  ReportReady = 'REPORT_READY',
  /** The user has viewed the health report generated for the body scan */
  ReportViewed = 'REPORT_VIEWED'
}

/** Encapsulates the data for a single body scan */
export type BodyScanSummary = {
  __typename?: 'BodyScanSummary';
  /**
   * The body fat percent computed from the user's body scan
   * @deprecated Use bodyFatPercentMetric instead
   */
  bodyFatPercent: Scalars['Float']['output'];
  /** The user's body fat as computed by the body scan. Only populated for successful scans. */
  bodyFatPercentMetric?: Maybe<BodyScanMetric>;
  /**
   * The date and time the body scan was created, from the subjective
   * point of view of the client, that is, ignoring TZ
   */
  clientCivilDate: Scalars['LocalDate']['output'];
  /** The user's fat mass as computed by the body scan. Only populated for successful scans. */
  fatMassInKgMetric?: Maybe<BodyScanMetric>;
  /** The user's lean mass as computed by the body scan. Only populated for successful scans. */
  leanMassInKgMetric?: Maybe<BodyScanMetric>;
  /** The lean mass percent computed from the user's body scan */
  leanMassPercent: Scalars['Float']['output'];
  /**
   * URL to retrieve the image byte stream, the image will be shown if the
   * show avatars toggle is on
   */
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  scanUuid: Scalars['UUID']['output'];
  status: BodyScanStatus;
  /** The user's waist to height ratio as computed by the body scan. Only populated for successful scans. */
  waistToHeightRatioMetric?: Maybe<BodyScanMetric>;
  /** The user's weight at the time of the body scan */
  weightInKg: Scalars['Float']['output'];
};

/**
 * Encapsulates the data needed to render the body scan home screen
 * tracker
 */
export type BodyScanTrackerState = {
  __typename?: 'BodyScanTrackerState';
  /** The number of completed body scans for the user */
  bodyScanCount: Scalars['Int']['output'];
  /**
   * Status of the user's current body scan, or null if the user
   * does not have an in-progress body scan
   */
  bodyScanInfo?: Maybe<BodyScanInfo>;
  /**
   * The taskList endpoint will return the body scan tracker assignment
   * every day for a user, even if it's not time to prompt that user to start
   * a new body scan. The mobile client should use this field to conditionally
   * hide the body scan home screen task card if the user should not actually
   * receive the body scan assignment for the given date
   */
  isValidAssignment: Scalars['Boolean']['output'];
};

export type BodyScanUploadMetadata = {
  __typename?: 'BodyScanUploadMetadata';
  scanUuid: Scalars['UUID']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** The client may specify any of these filter to control which body scans are returned from the backend */
export type BodyScansListFilters = {
  /**
   * If set to true, the response will only contain successfully completed body scans. By default all scans will be
   * included in the response.
   */
  onlySuccessful?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BodyTraceAttributionDataInput = {
  timestamp: Scalars['Int']['input'];
};

/** Specifies the user business type - B2B or B2C */
export enum BusinessType {
  B2B = 'B2B',
  B2C = 'B2C'
}

/** Button configuration for weight graph content. */
export type Button = {
  __typename?: 'Button';
  /** The size for the button. */
  size?: Maybe<ButtonSize>;
  /** The style for the button. */
  style?: Maybe<ButtonStyle>;
  /**
   * Target for the button. Acceptable targets are:
   * - Another screen via #<screen_id> ie #first
   * - An action via ?<action> acceptable actions are:
   * - CLOSE (ie ?CLOSE)
   * - BACK (ie ?BACK)
   * - A deeplink (ie https://link.noom.com/app?open=UPGRADE_OFFER&offer_id=plateau_ad)
   */
  target: Scalars['String']['output'];
  /** Text to put on the button. */
  text: Scalars['String']['output'];
};

/** Button size options. */
export enum ButtonSize {
  /** Large button size. */
  Large = 'LARGE',
  /** Medium button size. */
  Medium = 'MEDIUM',
  /** Small button size. */
  Small = 'SMALL',
  /** Default status for enums. */
  Unknown = 'UNKNOWN'
}

/** Button style options. */
export enum ButtonStyle {
  /** Primary button style. */
  Primary = 'PRIMARY',
  /** Secondary button style. */
  Secondary = 'SECONDARY',
  /** Tertiary button style. */
  Tertiary = 'TERTIARY',
  /** Default status for enums. */
  Unknown = 'UNKNOWN'
}

/** Survey answer entry */
export type BuyflowSurveyAnswer = {
  /** The answer as a JSON string */
  answerJson: Scalars['String']['input'];
  /** The question id */
  questionId: Scalars['String']['input'];
};

/**
 *  These values should be aligned with:
 *  - macros.proto (CalorieBudgetMacroTargetsProto)
 */
export type CalorieBudgetMacroTargets = {
  __typename?: 'CalorieBudgetMacroTargets';
  /**
   *  This value is used to calculate the recommended carbohydrate intake
   *  based on the total calorie budget.
   */
  carbsTargetPercentage: Scalars['Float']['output'];
  /**
   *  This value is used to calculate the recommended fat intake based on
   *  the total calorie budget.
   */
  fatTargetPercentage: Scalars['Float']['output'];
  /**
   *  This value is used to calculate the recommended protein intake based on
   *  the total calorie budget.
   */
  proteinTargetPercentage: Scalars['Float']['output'];
};

/**
 *  These values should be aligned with:
 *  - type CalorieBudgetMacroTargets (above)
 */
export type CalorieBudgetMacroTargetsInput = {
  carbsTargetPercentage: Scalars['Float']['input'];
  fatTargetPercentage: Scalars['Float']['input'];
  proteinTargetPercentage: Scalars['Float']['input'];
};

/**
 * A chat channel is a grouping structure for messages and provides an interaction
 * point for users and Noom humans (coaches, care, etc)
 */
export type ChatChannel = {
  __typename?: 'ChatChannel';
  /** Returns a list of surveys for the given user. */
  csatSurveys?: Maybe<Array<CsatSurvey>>;
  /** The id for the channel */
  id: Scalars['String']['output'];
};


/**
 * A chat channel is a grouping structure for messages and provides an interaction
 * point for users and Noom humans (coaches, care, etc)
 */
export type ChatChannelCsatSurveysArgs = {
  accessCode: Scalars['String']['input'];
};

export type ClientHints = {
  __typename?: 'ClientHints';
  enableClientPostCore?: Maybe<Scalars['Boolean']['output']>;
  usedDayOffsetStrategy?: Maybe<Scalars['Boolean']['output']>;
};

export type CoachAnnouncement = {
  __typename?: 'CoachAnnouncement';
  /** The number of visibility days for the announcement */
  activeDurationDays?: Maybe<Scalars['Int']['output']>;
  /** The first date when the announcement will be visible */
  activeStartTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  announcementId?: Maybe<Scalars['String']['output']>;
  /** If an announcements is ephemeral, it won't be shown to the users once it's been acknowledged */
  isEphemeral?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedByCduAccessCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Whether or not the coach should acknowledge that they've seen the announcement */
  requiresAcknowledgement?: Maybe<Scalars['Boolean']['output']>;
  /** Types of coaches that can see the announcement */
  ufcTypeConstraints?: Maybe<Array<Maybe<UfcType>>>;
};

export type CoachAnnouncementInfo = {
  __typename?: 'CoachAnnouncementInfo';
  /** The number of coaches that acknowledged the announcement */
  acknowledgedByCount?: Maybe<Scalars['Int']['output']>;
  coachAnnouncement?: Maybe<CoachAnnouncement>;
  /** The number of coaches that should see the announcement */
  targetedCoachesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of coaches that viewed the announcement */
  viewedByCount?: Maybe<Scalars['Int']['output']>;
};

export type CoachAnnouncementInput = {
  activeDurationInDays: Scalars['Int']['input'];
  activeStartTime: Scalars['OffsetDateTime']['input'];
  isEphemeral?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  requiresAcknowledgement: Scalars['Boolean']['input'];
  ufcTypeConstraints: Array<UfcType>;
};

export type CoachAnnouncementUserInteraction = {
  __typename?: 'CoachAnnouncementUserInteraction';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  coachAnnouncement: CoachAnnouncement;
  viewed: Scalars['Boolean']['output'];
};

export type CoachAnnouncementUserInteractions = {
  __typename?: 'CoachAnnouncementUserInteractions';
  items: Array<CoachAnnouncementUserInteraction>;
};

export type CoachAnnouncementUserInteractionsPaged = {
  __typename?: 'CoachAnnouncementUserInteractionsPaged';
  items: Array<CoachAnnouncementUserInteraction>;
  pageInfo?: Maybe<CursorPageInfo>;
};

export type CoachAnnouncementsConfig = {
  __typename?: 'CoachAnnouncementsConfig';
  isCoachAnnouncementsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type CoachAnnouncementsResult = {
  __typename?: 'CoachAnnouncementsResult';
  items: Array<CoachAnnouncementInfo>;
  pageInfo?: Maybe<CursorPageInfo>;
};

export type CoachAnnouncementsUserInteractionInfo = {
  __typename?: 'CoachAnnouncementsUserInteractionInfo';
  numberOfNewAcknowledgeAnnouncements?: Maybe<Scalars['Int']['output']>;
  numberOfUnseenAnnouncements?: Maybe<Scalars['Int']['output']>;
};

export type CoachingConfig = {
  __typename?: 'CoachingConfig';
  coachAnnouncementsConfig?: Maybe<CoachAnnouncementsConfig>;
  dashboardAiacConfig?: Maybe<DashboardAiacConfig>;
};

/**
 * Metrics to display in the goal achieved screen.
 * This will be displayed as a string, depending on the goal type. For example: "120/100 calories".
 */
export type ComparisonMetrics = {
  __typename?: 'ComparisonMetrics';
  /** Current value of the goal that user has achieved. */
  currentValue: Scalars['Int']['output'];
  /** Goal target value. */
  targetValue: Scalars['Int']['output'];
};

export type CompositeMealItem = {
  __typename?: 'CompositeMealItem';
  loggedUuid: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  originUuid?: Maybe<Scalars['UUID']['output']>;
  portion?: Maybe<Portion>;
  simpleMealItems: Array<SimpleMealItem>;
};

/** Content item for content section assignment. */
export type ContentItem = {
  __typename?: 'ContentItem';
  /** Content data */
  content?: Maybe<ContentItemData>;
  /** Content url of the content task assignment */
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** Description string|markdown for UI, e.g. 'Earn 250 Seeds' */
  description?: Maybe<ContentItemDescription>;
  /** Whether this content task activity has been completed */
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
};

/** A union for a different content types */
export type ContentItemData = ArtBreaksContent;

/** A union for description wrappers to allow markdown */
export type ContentItemDescription = MarkdownString | SeedsString;

/** Content section assignment for creative mindfulness tasks. */
export type ContentSectionAssignment = {
  __typename?: 'ContentSectionAssignment';
  /** List of the content activities */
  items?: Maybe<Array<ContentItem>>;
  /** Subtitle of the assignment, e.g. 'Elevate your mood with 2 minutes of art' */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the assignment, e.g. 'Take your weekly Art Break' */
  title?: Maybe<Scalars['String']['output']>;
};

export type CreatorsToExclude = {
  creators?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A customer satisfaction survey that can be presented to the user to get feedback */
export type CsatSurvey = {
  __typename?: 'CsatSurvey';
  id: Scalars['String']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  status: CsatSurveyStatus;
  textFeedback?: Maybe<Scalars['String']['output']>;
  type: CsatSurveyType;
};

/** The status of a given customer satisfaction survey */
export enum CsatSurveyStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Dismissed = 'DISMISSED',
  Expired = 'EXPIRED'
}

/** The type of a given customer satisfaction survey */
export enum CsatSurveyType {
  Deprecated = 'DEPRECATED',
  LongTermCoachInteraction = 'LONG_TERM_COACH_INTERACTION',
  ShortTermCoachInteraction = 'SHORT_TERM_COACH_INTERACTION'
}

/** Rewards celebration shown when user earns currency. It has two variants: modal and toast */
export type CurrencyEarnedCelebration = {
  __typename?: 'CurrencyEarnedCelebration';
  /** Currency amount earned in currency units. */
  amountEarned: Scalars['Int']['output'];
  /** Type of in-app flow. */
  flowType: CurrencyEarnedCelebrationFlowType;
  /** New rewards balance in currency units. */
  newBalance: Scalars['Int']['output'];
};

/**
 * Type of currency earned flow shown to the user.
 * In older versions of the app that do not recognize the flow type, the event will be ignored and nothing will be shown.
 */
export type CurrencyEarnedCelebrationFlowType = CurrencyEarnedCelebrationModal | CurrencyEarnedCelebrationToast;

/** Currency earned modal flow */
export type CurrencyEarnedCelebrationModal = {
  __typename?: 'CurrencyEarnedCelebrationModal';
  /** Reason for modal celebration. Drives the subtitle text shown in the modal. */
  earningReason?: Maybe<CurrencyEarnedReason>;
  /** Animation to display in the modal. Default is SEED_DROP_LARGE. */
  seedsAnimation?: Maybe<CurrencyEarnedModalSeedsAnimation>;
};

/** Currency earned toast flow */
export type CurrencyEarnedCelebrationToast = {
  __typename?: 'CurrencyEarnedCelebrationToast';
  /** Reason for toast notification. Used to drive text displayed in the toast. */
  earningReason?: Maybe<CurrencyEarnedReason>;
};

/**
 * DEPRECATED: use CurrencyEarnedCelebration instead.
 * We're simplifying the flow by removing the progress bar, reward unlocking, and first time earning experience.
 */
export type CurrencyEarnedEvent = {
  __typename?: 'CurrencyEarnedEvent';
  /** Currency amount earned in currency units. */
  amountEarned: Scalars['Int']['output'];
  /** New rewards balance in currency units. */
  newBalance: Scalars['Int']['output'];
  /** Type of in-app notification. */
  notification: CurrencyEarnedNotificationType;
};

/** DEPRECATED */
export type CurrencyEarnedModal = {
  __typename?: 'CurrencyEarnedModal';
  /**
   * Screens to show before the main currency earned modal flow is shown.
   * @deprecated Additional screens will be provided as part of the synchronous mutation result in the celebration field in GamificationActionResult
   */
  leadingScreens?: Maybe<Array<CurrencyEarnedModalScreen>>;
  /** Flow for modal notification. Used to drive specific screens used for the notification. */
  modalFlow: CurrencyEarnedModalFlow;
  /** Reason for modal notification. Drives the subtitle text shown in the modal. */
  modalReason: CurrencyEarnedModalReason;
  /** Animation to use in the first screen that shows the amount earned. Default is SEED_DROP_LARGE. */
  seedsAnimation?: Maybe<CurrencyEarnedModalSeedsAnimation>;
  /** Whether to show the progress bar. Default is true. */
  showProgressBar?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * DEPRECATED
 * Flow for the currency earned modal notification.
 * In older versions of the app that do not recognize the flow type, the event will be ignored and nothing will be shown.
 */
export type CurrencyEarnedModalFlow = CurrencyEarnedModalIntro | CurrencyEarnedModalProgress | CurrencyEarnedModalRewardUnlocked;

/** DEPRECATED */
export type CurrencyEarnedModalIntro = {
  __typename?: 'CurrencyEarnedModalIntro';
  /**
   * Next reward that can be unlocked.
   * This will typically be non-null but the field is optional to keep consistency with other CurrencyEarnedModalFlow subtypes.
   * This is due to a GraphQL limitation where fields with the same name across different child types of a union need to have the same type.
   */
  nextReward?: Maybe<CurrencyEarnedReward>;
  /** Title that is shown in intro flow. */
  title?: Maybe<CurrencyEarnedModalIntroTitle>;
};

/**
 * DEPRECATED
 * Intro title for the currency earned modal notification.
 * This drives title text shown in the modal.
 * In older versions of the app that do not recognize the modal reason, EARN_SEEDS_FOR_NOOMCOIN will be used.
 */
export enum CurrencyEarnedModalIntroTitle {
  /** Title will be similar to 'You get Seeds every time you earn your daily Noomcoin!' */
  EarnSeedsForNoomcoin = 'EARN_SEEDS_FOR_NOOMCOIN',
  /** Title will be similar to 'You get Seeds every time you earn your daily Noomcoin or weigh in for the first time in a week!' */
  EarnSeedsForNoomcoinAndFirstWeeklyWeighIn = 'EARN_SEEDS_FOR_NOOMCOIN_AND_FIRST_WEEKLY_WEIGH_IN'
}

/** DEPRECATED */
export type CurrencyEarnedModalProgress = {
  __typename?: 'CurrencyEarnedModalProgress';
  /** Next reward that can be unlocked. Null if no further reward can be unlocked. */
  nextReward?: Maybe<CurrencyEarnedReward>;
};

/**
 * DEPRECATED
 * Reason for the currency earned modal notification.
 * This drives subtitle text shown in the modal.
 * In older versions of the app that do not recognize the modal reason, the text will not be shown.
 */
export enum CurrencyEarnedModalReason {
  /** User completed first weigh-in in the current week. */
  FirstWeeklyWeighIn = 'FIRST_WEEKLY_WEIGH_IN',
  /** Reason for earning the currency will not be displayed. */
  None = 'NONE',
  /** User earned a Noomcoin. */
  Noomcoin = 'NOOMCOIN'
}

/** DEPRECATED */
export type CurrencyEarnedModalRewardUnlocked = {
  __typename?: 'CurrencyEarnedModalRewardUnlocked';
  /** Next reward that can be unlocked. Null if no further reward can be unlocked. */
  nextReward?: Maybe<CurrencyEarnedReward>;
  /** Reward that was unlocked. */
  unlockedReward: CurrencyEarnedReward;
};

/**
 * DEPRECATED
 * Union representing other screens that can be shown during the currency earned modal flow.
 * In older versions of the app that do not recognize the screen type, the screen will be ignored and not displayed.
 */
export type CurrencyEarnedModalScreen = GoalAchievedScreen;

/**
 * Animation to use in the first screen of the modal.
 * In older versions of the app that do not recognize the animation type:
 * - SEED_DROP_LARGE will be used for amounts >= 500
 * - SEED_DROP_MEDIUM will be used for amounts < 500
 */
export enum CurrencyEarnedModalSeedsAnimation {
  /** Large seed drop animation, used for larger earning amounts. */
  SeedDropLarge = 'SEED_DROP_LARGE',
  /** Medium seed drop animation, used for smaller earning amounts. */
  SeedDropMedium = 'SEED_DROP_MEDIUM'
}

/**
 * DEPRECATED
 * Type of currency earned notification shown to the user.
 * In older versions of the app that do not recognize the notification type, the event will be ignored and nothing will be shown.
 */
export type CurrencyEarnedNotificationType = CurrencyEarnedModal | CurrencyEarnedToast;

/**
 * Reason for the currency earned modal celebration.
 * This drives the copy shown on the modal and toast.
 * In older versions of the app that do not recognize the reason, in case of modal flow the text will not be shown, and in case of toast flow,
 * a generic earning message will be displayed.
 */
export enum CurrencyEarnedReason {
  /** User logged food/meal data. */
  FoodLogging = 'FOOD_LOGGING',
  /** User logged green calories. */
  GreenCaloriesLogging = 'GREEN_CALORIES_LOGGING',
  /** User achieved their green calorie goal. */
  GreenCalorieGoal = 'GREEN_CALORIE_GOAL',
  /** User earned a Noomcoin. */
  Noomcoin = 'NOOMCOIN',
  /** User has consumed a standalone content item (initially article, but type may expand). */
  StandaloneContent = 'STANDALONE_CONTENT',
  /** Steps goal achieved. */
  StepsGoalAchieved = 'STEPS_GOAL_ACHIEVED'
}

/** DEPRECATED */
export type CurrencyEarnedReward = {
  __typename?: 'CurrencyEarnedReward';
  /** Amount required to redeem reward in currency units. */
  amount: Scalars['Int']['output'];
  /** Image for the reward */
  image: RewardImage;
  /** Type of reward */
  type: CurrencyEarnedRewardType;
};

/** DEPRECATED */
export type CurrencyEarnedRewardCharity = {
  __typename?: 'CurrencyEarnedRewardCharity';
  /** Dummy field. Needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** DEPRECATED */
export type CurrencyEarnedRewardGiftCard = {
  __typename?: 'CurrencyEarnedRewardGiftCard';
  /** Monetary amount of gift card */
  value: Money;
};

/** DEPRECATED */
export type CurrencyEarnedRewardType = CurrencyEarnedRewardCharity | CurrencyEarnedRewardGiftCard;

/** DEPRECATED */
export type CurrencyEarnedToast = {
  __typename?: 'CurrencyEarnedToast';
  /** Reason for toast notification. Used to drive text and image assets used for the notification. */
  toastReason: CurrencyEarnedToastReason;
};

/**
 * DEPRECATED
 * Reason for the currency earned toast notification.
 * This drives text shown in the toast.
 * In older versions of the app that do not recognize the toast reason, the toast will not be shown.
 */
export enum CurrencyEarnedToastReason {
  /** User weighs in for the first time in a calendar week and receives bonus currency. */
  WeighInBonus = 'WEIGH_IN_BONUS'
}

/**
 *  These values should be aligned with:
 *  - noom_contracts/backend/curriculum/model/shared.proto (CurriculumEditorActionTypeProto.Value)
 */
export enum CurriculumEditorAction {
  Delete = 'DELETE',
  Publish = 'PUBLISH',
  SaveDraft = 'SAVE_DRAFT',
  SendToQa = 'SEND_TO_QA',
  Unknown = 'UNKNOWN'
}

/**  Details about an editor action. It shows when was an editor action last taken (if at all). */
export type CurriculumEditorActionDetails = {
  __typename?: 'CurriculumEditorActionDetails';
  /**
   *  The action last taken datetime can be null if we need to report about
   *  an action that has never been taken.
   */
  actionLastTakenAt?: Maybe<Scalars['LocalDateTime']['output']>;
  actionType: CurriculumEditorAction;
};

/**  Composes all details about actions editors can take or have taken */
export type CurriculumEditorActionsDetails = {
  __typename?: 'CurriculumEditorActionsDetails';
  editorActionDetails: Array<CurriculumEditorActionDetails>;
  nextEditorActions: Array<CurriculumEditorAction>;
};

/** Represents a module within a curriculum program */
export type CurriculumModule = {
  __typename?: 'CurriculumModule';
  /** Optional description of the module */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the module */
  moduleId: Scalars['UUID']['output'];
  /** Name of the module */
  name: Scalars['String']['output'];
};

export type CurriculumModules = {
  __typename?: 'CurriculumModules';
  curriculumModules: Array<CurriculumModule>;
};

/** Clients may specify filtering options to control which modules they need */
export type CurriculumModulesFilters = {
  /** If specified, filters the list of modules by this list of module IDs, in the same order */
  moduleIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If specified, filters the list of modules by module name */
  moduleName?: InputMaybe<Scalars['String']['input']>;
  /** If specified, returned modules must be referenced by the specified program */
  programConfigId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Basic definition of a program within a curriculum */
export type CurriculumProgram = {
  __typename?: 'CurriculumProgram';
  /** Program description. It's present for all programs, but it's optional in CurE, so it's optional here. */
  description?: Maybe<Scalars['String']['output']>;
  /** Program name */
  name: Scalars['String']['output'];
  /** Program Config ID coming from CurE. The same as in Curriculum API. */
  programConfigId: Scalars['UUID']['output'];
};

export type CurriculumPrograms = {
  __typename?: 'CurriculumPrograms';
  programs: Array<CurriculumProgram>;
};

export type CurriculumWorkflowActionInput = {
  actionId: Scalars['ID']['input'];
  actionType: CurriculumEditorAction;
  objectId: Scalars['ID']['input'];
  objectType: CurriculumWorkflowObjectType;
};

/**
 *  These values should be aligned with:
 *  - noom_contracts/backend/curriculum/model/shared.proto (CurriculumWorkflowActionObjectTypeProto)
 */
export enum CurriculumWorkflowObjectType {
  Foundation = 'FOUNDATION',
  Unknown = 'UNKNOWN'
}

/** Metadata for a single page from a paginated set of results */
export type CursorPageInfo = {
  __typename?: 'CursorPageInfo';
  /** Opaque token which represents the cursor for the current page */
  currentPageCursor: Scalars['String']['output'];
  /** Opaque token the client may use to fetch the next page, or null if none exists */
  nextPageCursor?: Maybe<Scalars['String']['output']>;
};

/** Provides the client the ability to paginate through a list of results */
export type CursorPagination = {
  /** Opaque token that specifies the page of results to retrieve. If unset, will default to the first page */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * The maximum number of results to include in the response. Note the backend may impose a stricter limit than
   * the client requests.
   */
  first: Scalars['Int']['input'];
  /** Dictates the order in which the results are returned. At least one Sort predicate must be defined */
  sort: Array<Sort>;
};

export type DailyStepsPayload = {
  __typename?: 'DailyStepsPayload';
  target: Scalars['Int']['output'];
};

export type DashboardAiacConfig = {
  __typename?: 'DashboardAiacConfig';
  isDashboardAiacEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type DecagonSignatureToken = {
  __typename?: 'DecagonSignatureToken';
  /** Specifies the user business type - B2B or B2C */
  businessType?: Maybe<BusinessType>;
  /** List of user entitlements */
  entitlements?: Maybe<Array<Scalars['String']['output']>>;
  /** Timestamp when the signature expires, represented as Unix epoch time */
  expiryEpochInSeconds: Scalars['Int']['output'];
  /** The external user id corresponding to the user access code for whom the signature is generated */
  externalUserId: Scalars['String']['output'];
  /** ID of the user's associated B2B Partner */
  partnerId?: Maybe<Scalars['Int']['output']>;
  /** Name of the user's associated B2B Partner */
  partnerName?: Maybe<Scalars['String']['output']>;
  /** HMAC-SHA256 signature used for validating the authenticity of the user with Decagon */
  signature: Scalars['String']['output'];
  /** User subscription tier */
  subscriptionTier?: Maybe<SubscriptionTier>;
};

/** Input for dismissing a customer satisfaction survey */
export type DismissCsatSurveyInput = {
  dismissedBy: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
};

export type Document = {
  __typename?: 'Document';
  isAccepted?: Maybe<Scalars['Boolean']['output']>;
  lastAcceptedTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  type: DocumentType;
};

/** Enum representing the different types of documents that can be accepted */
export enum DocumentType {
  /** Business Associate Agreement (BAA) */
  Baa = 'BAA',
  CoachLicenseAgreement = 'COACH_LICENSE_AGREEMENT',
  /** Data Processing Agreement (DPA) */
  Dpa = 'DPA',
  PrivacyPolicy = 'PRIVACY_POLICY'
}

/**
 *  These values should be aligned with:
 *  - measurement_type.proto (MeasurementTypeProto.Id)
 */
export enum DoseUnits {
  DoseInG = 'DOSE_IN_G',
  DoseInMcg = 'DOSE_IN_MCG',
  DoseInMg = 'DOSE_IN_MG',
  DoseInMl = 'DOSE_IN_ML',
  DoseInPercent = 'DOSE_IN_PERCENT',
  Unknown = 'UNKNOWN'
}

/** Encapsulates the data needed to render the calorie goal settings screen */
export type DynamicCalorieGoalSettingsState = {
  __typename?: 'DynamicCalorieGoalSettingsState';
  /** The activity level for the user */
  activityLevel: ActivityLevel;
  /** Whether the user has enabled external BMR source */
  externalBmrEnabled: Scalars['Boolean']['output'];
  /** Optional external BMR value, used to replace the BMR calculated from weight, height and gender */
  externalBmrValue?: Maybe<Scalars['Int']['output']>;
  /** Number of calories to manually add (if positive number) or subtract (if negative) from the calculated BMR. */
  manualCalorieAdjustment?: Maybe<Scalars['Int']['output']>;
};

/** DEPRECATED: Represents the different ways user can earn rewards currency */
export type EarnCurrencyMethod = {
  __typename?: 'EarnCurrencyMethod';
  /** The type of method used to earn rewards currency */
  type: EarnCurrencyMethodType;
  /** Currency units (seeds) awarded when requirements are met. */
  value: Scalars['Int']['output'];
};

/** DEPRECATED: The different types of earn currency methods */
export enum EarnCurrencyMethodType {
  /** Earn currency by earning 1 noomcoin */
  Noomcoin = 'NOOMCOIN',
  /** Earn currency by weighing in */
  WeighIn = 'WEIGH_IN'
}

export enum EatingReason {
  Bored = 'BORED',
  DontKnow = 'DONT_KNOW',
  Hungry = 'HUNGRY',
  ItWasTime = 'IT_WAS_TIME',
  Social = 'SOCIAL',
  Stressed = 'STRESSED',
  Tired = 'TIRED'
}

/** Status of user that is enrolled in rewards program. */
export type EnrolledRewardsState = {
  __typename?: 'EnrolledRewardsState';
  /** Rewards balance in currency units (seeds). */
  balance: Scalars['Int']['output'];
};

export type ExampleArticle = ExampleInterfaceContent & {
  __typename?: 'ExampleArticle';
  /**  Text body of the article */
  body: Scalars['String']['output'];
  /**  Short description of the article for previews */
  description: Scalars['String']['output'];
  /**  Title to show at the top */
  title: Scalars['String']['output'];
};

/**  If the items in your union don't need any fields of their own, consider using an enum instead */
export enum ExampleEnumStatus {
  Failure = 'FAILURE',
  /**  States in the enum don't have their own fields, but represent distinct, non-overlapping cases like unions do. */
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

/**
 *  If fields are shared between types, an interface allows for easier querying by specifying those fields once at the top
 *  level instead of repeating those fields for each type. The shared fields still have to be defined on each implementing
 *  type. Interfaces aren't allowed to end with the word interface!
 */
export type ExampleInterfaceContent = {
  /**  Short description of the article for previews */
  description: Scalars['String']['output'];
  /**  Title to show at the top */
  title: Scalars['String']['output'];
};

export type ExampleMultipleChoiceQuiz = ExampleInterfaceContent & {
  __typename?: 'ExampleMultipleChoiceQuiz';
  /**  Short description of the article for previews */
  description: Scalars['String']['output'];
  /**  List of multiple choice options to choose from */
  options: Array<Scalars['String']['output']>;
  /**  Title to show at the top */
  title: Scalars['String']['output'];
};

export type ExampleNullableItem = {
  __typename?: 'ExampleNullableItem';
  /**  Fields with ! are required */
  id: Scalars['ID']['output'];
  /**  Fields without ! can be omitted */
  optionalField?: Maybe<Scalars['String']['output']>;
};

/**
 *  Different list nullability states. Use the non-null list, non-null items by default. Nullable list items pose a risk.
 *  Only use nullableListNonNullItems if you need to model empty lists and null lists as separate states.
 */
export type ExampleNullableList = {
  __typename?: 'ExampleNullableList';
  /**  RECOMMENDED DEFAULT: list can't be null, items within the list can't be null */
  nonNullListNonNullItems: Array<ExampleNullableItem>;
  /**  AVOID: list can't be null, items within the list can be null */
  nonNullListNullableItems: Array<Maybe<ExampleNullableItem>>;
  /**  USE SPARINGLY: list can be null, items within the list can't be null */
  nullableListNonNullItems?: Maybe<Array<ExampleNullableItem>>;
  /**  AVOID: list can be null, items within the list can be null */
  nullableListNullableItems?: Maybe<Array<Maybe<ExampleNullableItem>>>;
};

export type ExampleStatusFailure = {
  __typename?: 'ExampleStatusFailure';
  /**  Error message to display to the user */
  errorMessage: Scalars['String']['output'];
};

/**
 *  In Protobuf, we achieve polymorphism using one-ofs, which specify an exclusive list of types that could be included.
 *  GraphQL doesn't have that construct, but does offer both interfaces and unions as mechanisms to model polymorphism.
 *  Both interfaces and unions have to be defined ahead of time. If it's unclear whether we'll need to support
 *  polymorphism, it's much better not to use a union or an interface since it may lead to restrictive or unintuitive type
 *  modeling down the line! In these cases, using a semantic comment above fields is a reasonable compromise.
 *  Unions are useful for describing types which have distinct possible states that don't have overlapping fields. They
 *  can be used to model scenarios which are more complicated than enums since each type within the union can have fields
 *  that are specific to that type. However, if there are shared fields between the types, an interface may be a better
 *  fit.
 */
export type ExampleStatusPending = {
  __typename?: 'ExampleStatusPending';
  /**  When the operation began */
  startTime?: Maybe<Scalars['DateTime']['output']>;
};

export type ExampleStatusSuccess = {
  __typename?: 'ExampleStatusSuccess';
  /**  Time the operation took to complete */
  timeElapsedMs: Scalars['Int']['output'];
};

export type ExampleStepData = {
  __typename?: 'ExampleStepData';
  /**  Step data is keyed by date (e.g. 2024-07-19) */
  date: Scalars['LocalDate']['output'];
  /**  Cumulative step count for the day */
  stepCount: Scalars['Int']['output'];
  /**  Target step count for the day */
  stepGoal: Scalars['Int']['output'];
};

export type ExampleStepsData = {
  __typename?: 'ExampleStepsData';
  /**
   *  In protobuf, we would likely model this as a map from date to step data, but here we model it as a list and use
   *  with the date field representing the key
   */
  stepData: Array<ExampleStepData>;
};

export type ExampleUnionStatus = ExampleStatusFailure | ExampleStatusPending | ExampleStatusSuccess;

export type ExternalCoachingTermsAndConditionsInfo = {
  __typename?: 'ExternalCoachingTermsAndConditionsInfo';
  documents: Array<Document>;
};

export type ExternalCoachingTermsAndConditionsInput = {
  documents: Array<DocumentType>;
};

export type FaceScanError = {
  __typename?: 'FaceScanError';
  /** Type of the error message */
  faceScanErrorType: FaceScanErrorType;
  /** Body of the error message */
  messageBody?: Maybe<Scalars['String']['output']>;
  /** Title of the error message */
  messageTitle?: Maybe<Scalars['String']['output']>;
};

export enum FaceScanErrorType {
  Disabled = 'DISABLED',
  FatalError = 'FATAL_ERROR',
  NonFatalError = 'NON_FATAL_ERROR',
  ProcessingError = 'PROCESSING_ERROR',
  ProviderDown = 'PROVIDER_DOWN',
  Unknown = 'UNKNOWN'
}

export type FaceScanImageAndBackground = {
  __typename?: 'FaceScanImageAndBackground';
  imageBackgroundDownloadUrl: Scalars['String']['output'];
  imageDownloadUrl: Scalars['String']['output'];
};

export type FaceScanImageProcessingState = FaceScanError | FaceScanNotStarted | FaceScanProcessing | FaceScanResults;

export type FaceScanImageUploadHeader = {
  __typename?: 'FaceScanImageUploadHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FaceScanInitializationInfo = {
  __typename?: 'FaceScanInitializationInfo';
  errorMessageBody?: Maybe<Scalars['String']['output']>;
  errorMessageTitle?: Maybe<Scalars['String']['output']>;
  processingScreenData: FaceScanProcessing;
  state: FaceScanInitializationState;
  uploadContentType: Scalars['String']['output'];
  uploadHeaders: Array<FaceScanImageUploadHeader>;
  uploadMethod: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export enum FaceScanInitializationState {
  Disabled = 'DISABLED',
  Error = 'ERROR',
  FatalError = 'FATAL_ERROR',
  NonFatalError = 'NON_FATAL_ERROR',
  Ok = 'OK',
  Unknown = 'UNKNOWN'
}

export type FaceScanLoadingScreenTips = {
  __typename?: 'FaceScanLoadingScreenTips';
  otherLines: Scalars['String']['output'];
  sourceLine: Scalars['String']['output'];
  topLine: Scalars['String']['output'];
};

export type FaceScanNotStarted = {
  __typename?: 'FaceScanNotStarted';
  /** Message in case we need to notify anything */
  message?: Maybe<Scalars['String']['output']>;
};

export type FaceScanProcessing = {
  __typename?: 'FaceScanProcessing';
  /** The image to show while the face scan gets processed */
  image: Scalars['String']['output'];
  /** Messages to show with the loading bar/icon to the user while the images get processed */
  loadingScreenAnalysisMessages: Array<Scalars['String']['output']>;
  /** Messages to show in the LOADING screen to the user while the images get processed */
  loadingScreenTips: Array<FaceScanLoadingScreenTips>;
};

export type FaceScanResults = {
  __typename?: 'FaceScanResults';
  badHabitsImageAndBackground: FaceScanImageAndBackground;
  /** @deprecated Use badHabitsImageAndBackground instead */
  badHabitsImageDownloadUrl: Scalars['String']['output'];
  badHabitsItems: Array<Scalars['String']['output']>;
  /** @deprecated Use badHabitsMarkdownHeader and badHabitsItems instead */
  badHabitsMarkdown: Scalars['String']['output'];
  badHabitsMarkdownHeader: Scalars['String']['output'];
  badHabitsSwitchButton: Scalars['String']['output'];
  choiceButton: Scalars['String']['output'];
  goodHabitsImageAndBackground: FaceScanImageAndBackground;
  /** @deprecated Use goodHabitsImageAndBackground instead */
  goodHabitsImageDownloadUrl: Scalars['String']['output'];
  goodHabitsItems: Array<Scalars['String']['output']>;
  /** @deprecated Use goodHabitsMarkdownHeader and goodHabitsItems instead */
  goodHabitsMarkdown: Scalars['String']['output'];
  goodHabitsMarkdownHeader: Scalars['String']['output'];
  goodHabitsSwitchButton: Scalars['String']['output'];
  shareables: Array<Maybe<ShareableMedia>>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Enumerates the facial blood scan 3rd party providers */
export enum FacialBloodScanProvider {
  Anura = 'ANURA'
}

export type FacialBloodScanToken = {
  __typename?: 'FacialBloodScanToken';
  /** Authentication token used for API authorization */
  authToken: Scalars['String']['output'];
  /** One time token used to obtain a new auth token when it expires */
  refreshToken: Scalars['String']['output'];
  /** Time in seconds until the refresh token expires */
  refreshTokenExpirationSeconds: Scalars['Int']['output'];
  /** Time in seconds until the auth token expires */
  tokenExpirationSeconds: Scalars['Int']['output'];
};

export type FacialBloodScanTokenInput = {
  anuraTokenInput?: InputMaybe<AnuraTokenInput>;
};

/** Fixed content (e.g. static articles) served by url */
export type FixedContent = {
  __typename?: 'FixedContent';
  /** Url for audio version of FixedContent */
  audioSourceUrl?: Maybe<Scalars['String']['output']>;
  /** Describes to user how long to expect reading takes */
  averageReadingDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  /** Id for content analytics */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Indicates how to display FixedContent */
  contentType: FixedContentType;
  /** Url for fixed content */
  contentUrl: Scalars['String']['output'];
  /** ImageUrl for FixedContent */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Display title */
  title: Scalars['String']['output'];
};

/** Groups fixed content into titled sections */
export type FixedContentSection = {
  __typename?: 'FixedContentSection';
  /** List of FixedContent for section of fixed content */
  fixedContentList: Array<FixedContent>;
  /** Section Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Differentiates between articles and future types */
export enum FixedContentType {
  /** Article - contentUrl driven fixed content */
  Article = 'ARTICLE',
  /** Unknown type required by proto */
  FixedContentTypeUnknown = 'FIXED_CONTENT_TYPE_UNKNOWN'
}

export type FloatRange = {
  __typename?: 'FloatRange';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type FoodCalorieBar = {
  __typename?: 'FoodCalorieBar';
  foodColor?: Maybe<FoodColor>;
  goalInCals: Scalars['Float']['output'];
  valueInCals: Scalars['Float']['output'];
};

/**
 *  These values should be aligned with:
 *  - food_colors.proto (FoodColorProto)
 */
export enum FoodColor {
  Green = 'GREEN',
  Orange = 'ORANGE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  Yellow = 'YELLOW'
}

/**
 * Information about an individual food item that was logged.
 *
 * Note: we have calories, greenCalories, yellowCalories and orangeCalories as nullable because
 * some food items are expected to have only calories and color while others are expected to not have
 * the calories field populated, but the green, yellow or orangle calories fields populated.
 *
 * masterFoodUuid, customFoodUuid and name attributes will not be used by the backend at initial feature launch.
 */
export type FoodItemInput = {
  /** Calories in the food */
  calories?: InputMaybe<Scalars['Float']['input']>;
  /** Food color */
  color: FoodColor;
  /** Custom food UUID (either this will be present or masterFoodUuid) */
  customFoodUuid?: InputMaybe<Scalars['String']['input']>;
  /** Green calories of the food entry (if applicable) */
  greenCalories?: InputMaybe<Scalars['Float']['input']>;
  /** Master food UUID (either this will be present or customFoodUuid) */
  masterFoodUuid?: InputMaybe<Scalars['String']['input']>;
  /** The name of the food */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Orange calories of the food entry (if applicable) */
  orangeCalories?: InputMaybe<Scalars['Float']['input']>;
  /** Yellow calories of the food entry (if applicable) */
  yellowCalories?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Data input type that contains features-specific data sent from the client. This is used to map Gamification action type to Domain SOA.
 * The team who's integrating a feature with rewards is responsible for creating an input type for their feature.
 * It's up to the team to decide what data to send to the backend - the context needed to process the action can be provided either by the client, or the backend.
 */
export type GamificationActionDataInput = {
  /** Food logging data input */
  foodLogging?: InputMaybe<GamificationActionFoodLoggingDataInput>;
  /** Standalone content data input */
  standaloneContent?: InputMaybe<GamificationActionStandaloneContentDataInput>;
  /** Step banking data input */
  stepBanking?: InputMaybe<GamificationActionStepBankingDataInput>;
};

/** Data input for food logging gamification action - triggered when user logs or updates a meal */
export type GamificationActionFoodLoggingDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** Total green calories across all meals for the current day */
  greenCaloriesCurrent: Scalars['Float']['input'];
  /** Current green calories goal for the user */
  greenCaloriesTarget: Scalars['Int']['input'];
  /** True indicates a new meal has been recorded, false means an existing meal has been updated */
  isNewMeal: Scalars['Boolean']['input'];
};

/** Result of processing a gamification action - returns celebrations and processing results */
export type GamificationActionResult = {
  __typename?: 'GamificationActionResult';
  /**
   * List of celebrations triggered by the gamification action (one action can trigger multiple celebrations)
   * E.g. when a user achieves daily goal with an action, celebrations list would contain GoalAchieved, and CurrencyEarnedEvent(modal) celebrations
   */
  celebrations?: Maybe<Array<GamificationCelebration>>;
  /** Processing result related to rewards */
  rewardsResult?: Maybe<GamificationActionRewardsResult>;
  /** Processing results related to streaks */
  streaksResults?: Maybe<Array<Maybe<GamificationActionStreaksResult>>>;
};

/**
 * Processing a rewards-specific gamification action didn't trigger a balance update.
 * In the future this can be expanded with an explanation on why the balance was not updated.
 */
export type GamificationActionRewardsBalanceUnchanged = {
  __typename?: 'GamificationActionRewardsBalanceUnchanged';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a balance update for a specific reward within a gamification action */
export type GamificationActionRewardsBalanceUpdate = {
  __typename?: 'GamificationActionRewardsBalanceUpdate';
  /** The amount of currency earned for this specific reward */
  amountEarned: Scalars['Int']['output'];
  /** The reason why currency was earned, e.g. completing a Noomcoin */
  reason: GamificationActionRewardsBalanceUpdateReason;
};

/**
 * Reason for the currency balance update.
 * Used on clients for cases when we want to break down the total amount earned - e.g. for analytics
 */
export enum GamificationActionRewardsBalanceUpdateReason {
  /** User logged food/meal data. */
  FoodLogging = 'FOOD_LOGGING',
  /** User logged green calories. */
  GreenCaloriesLogging = 'GREEN_CALORIES_LOGGING',
  /** User achieved their green calorie goal. */
  GreenCalorieGoal = 'GREEN_CALORIE_GOAL',
  /** User earned a Noomcoin */
  Noomcoin = 'NOOMCOIN',
  /** User completed standalone content item */
  StandaloneContent = 'STANDALONE_CONTENT',
  /** User banked steps */
  StepBanking = 'STEP_BANKING',
  /** User banked step goal */
  StepGoalBanking = 'STEP_GOAL_BANKING',
  /** User banked steps onboarding reward */
  StepOnboardingRewardBanking = 'STEP_ONBOARDING_REWARD_BANKING'
}

/** Processing a rewards-specific gamification action triggered a balance update */
export type GamificationActionRewardsBalanceUpdated = {
  __typename?: 'GamificationActionRewardsBalanceUpdated';
  /** Total amount of currency earned from the action */
  amountEarned: Scalars['Int']['output'];
  /** Breakdown of balance updates by individual reward type - sum equals amountEarned */
  balanceUpdatesPerReward?: Maybe<Array<GamificationActionRewardsBalanceUpdate>>;
};

/**
 * Processing a rewards-specific gamification action failed.
 * In the future this can be expanded with a field that indicates the cause of failure.
 */
export type GamificationActionRewardsFailure = {
  __typename?: 'GamificationActionRewardsFailure';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Union of rewards specific processing results */
export type GamificationActionRewardsResult = GamificationActionRewardsBalanceUnchanged | GamificationActionRewardsBalanceUpdated | GamificationActionRewardsFailure;

/** Data input for standalone content consumed gamification action */
export type GamificationActionStandaloneContentDataInput = {
  /** User's local date */
  clientDate: Scalars['LocalDate']['input'];
};

/** Data input for step banking gamification action - data for generating granting context is provided by the domain SOA */
export type GamificationActionStepBankingDataInput = {
  /** The user's selected date, for determining the range of steps measurements to use */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** Flag, used to determine if required to include onboarding steps reward to the list of gamification actions */
  onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's current selected program ID, used for determining the user's current steps goal */
  programId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Processing a streaks-specific gamification action failed.
 * In the future this can be expanded with a field that indicates the cause of failure.
 */
export type GamificationActionStreakFailure = {
  __typename?: 'GamificationActionStreakFailure';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Processing a streak update succeeded.
 * In the future this can be expanded with fields expanding on the result of update.
 */
export type GamificationActionStreakUpdated = {
  __typename?: 'GamificationActionStreakUpdated';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** The wrapper for a processing result for a specific streak type. */
export type GamificationActionStreaksResult = {
  __typename?: 'GamificationActionStreaksResult';
  /** Processing result for this specific streak type */
  result?: Maybe<StreakProcessingResult>;
  /** Type of the streak the result is referring to */
  streakType?: Maybe<StreakType>;
};

/**
 * Union type representing different types of celebrations that can be triggered by gamification actions.
 * In older versions of the app that do not recognize the celebration type, the celebration will be ignored.
 */
export type GamificationCelebration = CurrencyEarnedCelebration | GoalAchievedCelebration | StreakIncreasedCelebration;

/** Celebration shown when user achieves a goal. */
export type GoalAchievedCelebration = {
  __typename?: 'GoalAchievedCelebration';
  /** Metrics to display in the goal achieved celebration. If null, metrics will not be displayed. */
  metrics?: Maybe<GoalAchievedMetrics>;
  /** Type of goal achieved (required). */
  type?: Maybe<GoalAchievedType>;
};

/**
 * Union type for the metrics to display in the goal achieved screen.
 * In older versions of the app that do not recognize the metrics type, metrics will not be displayed.
 */
export type GoalAchievedMetrics = ComparisonMetrics;

/** DEPRECATED: use GoalAchievedCelebration instead */
export type GoalAchievedScreen = {
  __typename?: 'GoalAchievedScreen';
  /** Metrics to display in the goal achieved screen. If null, metrics will not be displayed. */
  metrics?: Maybe<GoalAchievedMetrics>;
  /** Type of goal achieved (required). */
  type?: Maybe<GoalAchievedType>;
};

/**
 * Type of goal achieved.
 * This drives UI assets used in the goal achieved screen - highlight color, goal text, and header animation.
 * In older versions of the app that do not recognize the goal achieved type, the goal achieved screen will be ignored and not displayed.
 */
export enum GoalAchievedType {
  /** Green calorie goal. */
  GreenCalorie = 'GREEN_CALORIE',
  /** Steps goal */
  Steps = 'STEPS'
}

/**
 *  These values should be aligned with:
 *  - goal_id_enum.proto (GoalIdEnumProto.Value.Id)
 */
export enum GoalId {
  DailyStepsAtLeastCount = 'DAILY_STEPS_AT_LEAST_COUNT',
  DrinkAtLeastWaterUnits = 'DRINK_AT_LEAST_WATER_UNITS',
  IngestBelowCalorieUnits = 'INGEST_BELOW_CALORIE_UNITS',
  LogBloodGlucoseReadingAtLeastCount = 'LOG_BLOOD_GLUCOSE_READING_AT_LEAST_COUNT',
  LogGreenCaloriesAtLeastCount = 'LOG_GREEN_CALORIES_AT_LEAST_COUNT',
  LogHighBloodGlucoseReading = 'LOG_HIGH_BLOOD_GLUCOSE_READING',
  LogLowBloodGlucoseReading = 'LOG_LOW_BLOOD_GLUCOSE_READING',
  LogMealsAtLeastCount = 'LOG_MEALS_AT_LEAST_COUNT',
  LogMedicationDoseAtLeastCount = 'LOG_MEDICATION_DOSE_AT_LEAST_COUNT',
  LogMedicationMetforminDoseAtLeastCount = 'LOG_MEDICATION_METFORMIN_DOSE_AT_LEAST_COUNT',
  LogVeryHighBloodGlucoseReading = 'LOG_VERY_HIGH_BLOOD_GLUCOSE_READING',
  LogVeryLowBloodGlucoseReading = 'LOG_VERY_LOW_BLOOD_GLUCOSE_READING',
  TakeAtLeastMedicationDoseCount = 'TAKE_AT_LEAST_MEDICATION_DOSE_COUNT',
  Unknown = 'UNKNOWN'
}

export type GoalMetadata = GreenCaloriesGoalMetadata | MedicationGoalMetadata | StepGoalMetadata | WaterGoalMetadata;

export type GoalTarget = {
  greenCaloriesTarget?: InputMaybe<GreenCaloriesTarget>;
  stepTarget?: InputMaybe<StepTarget>;
  waterTarget?: InputMaybe<WaterTarget>;
};

export type GoogleFitAttributionDataInput = {
  /** Package name of the app inserting data. */
  packageName: Scalars['String']['input'];
  /** Name of the app inserting data in Google Fit. */
  sourceName: Scalars['String']['input'];
  timestamp: Scalars['Int']['input'];
};

export type GreenCaloriesGoalMetadata = {
  __typename?: 'GreenCaloriesGoalMetadata';
  minGreenCalories?: Maybe<Scalars['Int']['output']>;
};

export type GreenCaloriesTarget = {
  minGreenCalories?: InputMaybe<Scalars['Int']['input']>;
};

export enum HeaderAnimation {
  Apple = 'APPLE',
  BarGraph = 'BAR_GRAPH',
  Camera = 'CAMERA',
  One = 'ONE',
  Plant = 'PLANT',
  Rocket = 'ROCKET',
  Target = 'TARGET'
}

export type HealthConnectAttributionDataInput = {
  /** List of package names of the apps inserting data. Steps data could have multiple data providers. Other types of data will have one provider. */
  packageNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type HealthKitAttributionDataInput = {
  /** The bundle identifier of the app inserting the data. */
  bundleIdentifier: Scalars['String']['input'];
  /** Name of the app inserting data in HealthKit. */
  sourceName: Scalars['String']['input'];
};

/** Content for a large home screen ad placement. */
export type HomeLargeContent = {
  __typename?: 'HomeLargeContent';
  /** A bullet list of benefits with markdown encoding. */
  benefitKeysMarkdown: Array<Scalars['String']['output']>;
  /** The text of the CTA button. */
  buttonText: Scalars['String']['output'];
  /** Text for the disclaimer. */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** The url that should be opened when the ad is tapped. */
  targetUrl: Scalars['String']['output'];
  /** The title of the testimonial section. */
  testimonialTitle?: Maybe<Scalars['String']['output']>;
  /** The title of the content block. */
  title?: Maybe<Scalars['String']['output']>;
  /** A list of testimonials. */
  upsellAdTestimonial?: Maybe<Array<UpsellAdTestimonial>>;
};

/**
 *  Available page types for the home screen carousel.
 *  Pages handles their own state.
 */
export enum HomeScreenCarouselPage {
  CalorieBudget = 'CALORIE_BUDGET',
  FoodColorBreakdown = 'FOOD_COLOR_BREAKDOWN',
  MacroBudgets = 'MACRO_BUDGETS',
  ProteinBudget = 'PROTEIN_BUDGET',
  ProteinFocusedMacroBudgets = 'PROTEIN_FOCUSED_MACRO_BUDGETS'
}

export type HomeScreenCarouselState = {
  __typename?: 'HomeScreenCarouselState';
  pages: Array<HomeScreenCarouselPage>;
};

/** Content for a single tile in the home screen carousel ad placement. */
export type HomeScreenCarouselTileContent = {
  __typename?: 'HomeScreenCarouselTileContent';
  /** Call to action button for the carousel tile. */
  button?: Maybe<Button>;
  /** Header for this carousel tile. */
  header?: Maybe<Scalars['String']['output']>;
  /** URL of the image to display in this carousel tile. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Text to display on the carousel tile. */
  text?: Maybe<Scalars['String']['output']>;
  /**
   * Title for the entire carousel section.
   * This value is expected to be the same across all tiles and is typically taken from the first tile.
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The upsell ad type for this carousel tile. Note that each tile can be a different
   * type and the type of the ad UpsellAdData may not be representative of all of the ads.
   */
  upsellAdType?: Maybe<UpsellAdType>;
};

/** Home screen navigation configuration - drives the navigation view shown in toolbar */
export type HomeScreenNavigation = {
  __typename?: 'HomeScreenNavigation';
  /** Type of home screen navigation */
  type: HomeScreenNavigationType;
};

/** Available types of home screen navigation */
export enum HomeScreenNavigationType {
  /** Daily navigation */
  DailyNavigation = 'DAILY_NAVIGATION',
  /** No navigation */
  NoNavigation = 'NO_NAVIGATION',
  /** Weekly navigation - for users with Noomcoin */
  WeeklyNavigation = 'WEEKLY_NAVIGATION'
}

/** DEPRECATED: Display the full list of available methods from RewardsLevels.methods. This type is not currently supported by clients */
export type HowToEarnCurrencyFullList = {
  __typename?: 'HowToEarnCurrencyFullList';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Display the generic message with a link to a FAQ page */
export type HowToEarnCurrencyGeneric = {
  __typename?: 'HowToEarnCurrencyGeneric';
  /** WebView URL for rewards learn more webpage */
  learnMoreWebViewUrl: Scalars['String']['output'];
};

/** Display noomcoin information only */
export type HowToEarnCurrencyNoomcoin = {
  __typename?: 'HowToEarnCurrencyNoomcoin';
  /** Currency units (seeds) awarded when requirements are met. */
  currencyAmountAwarded: Scalars['Int']['output'];
  /** WebView URL for rewards learn more webpage */
  learnMoreWebViewUrl: Scalars['String']['output'];
};

/** Union type representing the type of How to earn currency screen to display */
export type HowToEarnCurrencyType = HowToEarnCurrencyFullList | HowToEarnCurrencyGeneric | HowToEarnCurrencyNoomcoin;

/** CTA for insight (example is quick reply with a deep link, etc.). */
export type InsightCallToAction = {
  __typename?: 'InsightCallToAction';
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** Feedback from the user on the value of the insight */
export type InsightFeedback = {
  /** The user's rating for the insight */
  rating?: Maybe<InsightFeedbackRating>;
};

/** Options for how the user can rate an insight */
export enum InsightFeedbackRating {
  ThumbsDown = 'THUMBS_DOWN',
  ThumbsUp = 'THUMBS_UP'
}

export type InterstitialState = {
  __typename?: 'InterstitialState';
  lastShownDate?: Maybe<Scalars['LocalDate']['output']>;
  shownCount: Scalars['Int']['output'];
};

export type Interstitials = {
  __typename?: 'Interstitials';
  communityHint: InterstitialState;
  communityIntroAnnouncement: InterstitialState;
  successKitIntro: InterstitialState;
};

export type LessonsData = {
  __typename?: 'LessonsData';
  measurementCivilDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  secondsRead: Scalars['Int']['output'];
};

export type LessonsDataInput = {
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
  secondsRead: Scalars['Int']['input'];
};

/** A wrapper input type for an inclusive date range */
export type LocalDateRangeInput = {
  /** The inclusive end day of the date range */
  endDate: Scalars['LocalDate']['input'];
  /** The inclusive starting day of the date range */
  startDate: Scalars['LocalDate']['input'];
};

export type LocalDateTimeRange = {
  __typename?: 'LocalDateTimeRange';
  end: Scalars['LocalDateTime']['output'];
  start: Scalars['LocalDateTime']['output'];
};

export type LogMealsTrackerPayload = {
  __typename?: 'LogMealsTrackerPayload';
  /** Different configurable pages for a tracker */
  pages: Array<MealLoggingTrackerPage>;
  /** Optional task subtitle override */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Optional task title override */
  title?: Maybe<Scalars['String']['output']>;
  /** What variant of the tracker are we showing. */
  variant: MealLoggingTrackerVariant;
};

/** Logged meal information used to generate an AI insight for the user. */
export type LoggedMealInput = {
  /** Access code of user that meal was logged for. */
  accessCode: Scalars['String']['input'];
  /** The food items that the user logged for the meal. */
  foodItems: Array<FoodItemInput>;
  /** Date of the meal. */
  mealDate: Scalars['LocalDate']['input'];
  /** The slot for the logged meal. */
  mealSlot: MealSlot;
};

/**  Encapsulates the data needed to render the macro monitoring settings screen */
export type MacroMonitoringSettingsState = {
  __typename?: 'MacroMonitoringSettingsState';
  /**  Whether the user has enabled macro monitoring on their account */
  isEnabled: Scalars['Boolean']['output'];
  /**  The macronutrient target percentage values based on the users calorie budget */
  macroTargets: CalorieBudgetMacroTargets;
};

/** Input for marking standalone content as consumed */
export type MarkStandaloneContentConsumedInput = {
  /** Access code that pseudo-identifies the user (optional, can be obtained from headers) */
  accessCode?: InputMaybe<Scalars['String']['input']>;
  /** Opaque round-trip payload for tracking content consumption state */
  contentConsumedPayload: Scalars['String']['input'];
  /** Represents the client's civil date the content is requested for */
  contentLocalDate: Scalars['LocalDate']['input'];
};

/** Response for marking standalone content as consumed */
export type MarkStandaloneContentConsumedResponse = {
  __typename?: 'MarkStandaloneContentConsumedResponse';
  /** The updated standalone content item */
  content: StandaloneContent;
};

/** A wrapper for the markdown string Content Item description */
export type MarkdownString = {
  __typename?: 'MarkdownString';
  /** Markdown string value */
  value: Scalars['String']['output'];
};

/**
 *  These values should be aligned with:
 *  - blood_glucose_data.proto (BloodGlucoseDataProto)
 */
export enum MealContext {
  AfterAfternoonSnack = 'AFTER_AFTERNOON_SNACK',
  AfterBreakfast = 'AFTER_BREAKFAST',
  AfterDinner = 'AFTER_DINNER',
  AfterEveningSnack = 'AFTER_EVENING_SNACK',
  AfterLunch = 'AFTER_LUNCH',
  AfterMorningSnack = 'AFTER_MORNING_SNACK',
  BeforeAfternoonSnack = 'BEFORE_AFTERNOON_SNACK',
  BeforeBed = 'BEFORE_BED',
  BeforeBreakfast = 'BEFORE_BREAKFAST',
  BeforeDinner = 'BEFORE_DINNER',
  BeforeEveningSnack = 'BEFORE_EVENING_SNACK',
  BeforeLunch = 'BEFORE_LUNCH',
  BeforeMorningSnack = 'BEFORE_MORNING_SNACK',
  Fasting = 'FASTING',
  Unknown = 'UNKNOWN'
}

export type MealData = {
  __typename?: 'MealData';
  mealItems: Array<MealItemOneOf>;
  mealNotes?: Maybe<MealNotes>;
  mealPhotos?: Maybe<MealPhotos>;
  mealSlot?: Maybe<MealSlot>;
  mealTimeSlot?: Maybe<MealTimeSlot>;
  measurementCivilDate: Scalars['LocalDate']['output'];
};

export type MealItemOneOf = {
  __typename?: 'MealItemOneOf';
  compositeMealItem?: Maybe<CompositeMealItem>;
  simpleMealItem?: Maybe<SimpleMealItem>;
};

/** Feature state containing the configuration for meal logging method selector UI */
export type MealLoggingMethodSelectorFeatureState = {
  __typename?: 'MealLoggingMethodSelectorFeatureState';
  /** List of rows containing meal logging option cards */
  rows: Array<MealLoggingSelectorRow>;
};

/**
 * Available meal logging methods
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionType)
 */
export enum MealLoggingOption {
  /** Log meals by scanning product barcodes */
  Barcode = 'BARCODE',
  /** View previously recorded meal history */
  History = 'HISTORY',
  /** Log meals by taking a photo */
  Photo = 'PHOTO',
  /** Log meals by searching a food database */
  Search = 'SEARCH',
  /** Default/unspecified meal logging option type */
  UnknownType = 'UNKNOWN_TYPE',
  /** Log meals using voice recording */
  Voice = 'VOICE'
}

/**
 * Availability states for meal logging options
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionAvailability)
 */
export enum MealLoggingOptionAvailability {
  /** Option is temporarily unavailable */
  Disabled = 'DISABLED',
  /** Option is available and can be used */
  Enabled = 'ENABLED',
  /** Option is locked and requires special access or upgrade */
  Locked = 'LOCKED',
  /** Default/unspecified availability state */
  UnknownAvailability = 'UNKNOWN_AVAILABILITY'
}

/** Individual card representing a meal logging method option */
export type MealLoggingOptionCard = {
  __typename?: 'MealLoggingOptionCard';
  /** Current availability state of this logging option */
  availability: MealLoggingOptionAvailability;
  /** The specific meal logging method this card represents */
  option: MealLoggingOption;
  /** Display size of the card in the UI */
  size: MealLoggingOptionCardSize;
  /** Tags to highlight special features or promotions */
  tags: Array<MealLoggingOptionCardTag>;
};

/**
 * Display sizes for meal logging option cards
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionCardSize)
 */
export enum MealLoggingOptionCardSize {
  /** Large card size for prominent display */
  Large = 'LARGE',
  /** Medium card size for standard display */
  Medium = 'MEDIUM',
  /** Small card size for compact display */
  Small = 'SMALL',
  /** Default/unspecified card size */
  UnknownSize = 'UNKNOWN_SIZE'
}

/**
 * Optional tags for meal logging option cards
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionCardTagProto)
 */
export enum MealLoggingOptionCardTag {
  /** Indicates a feature the user should try */
  TryMe = 'TRY_ME',
  /** Default/unspecified card tag */
  UnknownTag = 'UNKNOWN_TAG'
}

export type MealLoggingProgressBarPage = {
  __typename?: 'MealLoggingProgressBarPage';
  bars: Array<MealLoggingTrackerBar>;
};

/** A row in the meal logging method selector containing option cards */
export type MealLoggingSelectorRow = {
  __typename?: 'MealLoggingSelectorRow';
  /** List of meal logging option cards in this row */
  cards: Array<MealLoggingOptionCard>;
};

export type MealLoggingTrackerBar = FoodCalorieBar;

export type MealLoggingTrackerPage = MealLoggingProgressBarPage;

export enum MealLoggingTrackerVariant {
  /** Regular configurable food tracking, showing progress bars for food calories or mass. */
  Default = 'DEFAULT',
  /** The state shown for freemium users before they set their green goal. */
  GreenGoalOnboarding = 'GREEN_GOAL_ONBOARDING',
  Unknown = 'UNKNOWN'
}

export type MealNotes = {
  __typename?: 'MealNotes';
  eatingReason?: Maybe<EatingReason>;
  mealOrigin?: Maybe<MealOrigin>;
};

export enum MealOrigin {
  DontKnow = 'DONT_KNOW',
  FastFood = 'FAST_FOOD',
  Homemade = 'HOMEMADE',
  Prepackaged = 'PREPACKAGED',
  Raw = 'RAW',
  Restaurant = 'RESTAURANT'
}

export type MealPhoto = {
  __typename?: 'MealPhoto';
  url: Scalars['String']['output'];
};

export type MealPhotos = {
  __typename?: 'MealPhotos';
  photos?: Maybe<Array<MealPhoto>>;
};

/**
 *  These values should be aligned with:
 *  - meal_slots.proto (MealSlotsProto.MealSlot)
 */
export enum MealSlot {
  AfternoonSnack = 'AFTERNOON_SNACK',
  Breakfast = 'BREAKFAST',
  Dinner = 'DINNER',
  EveningSnack = 'EVENING_SNACK',
  Lunch = 'LUNCH',
  MorningSnack = 'MORNING_SNACK',
  Unknown = 'UNKNOWN'
}

export type MealTimeSlot = {
  __typename?: 'MealTimeSlot';
  hour: Scalars['Int']['output'];
  minute: Scalars['Int']['output'];
};

/**
 *  These values should be aligned with:
 *  - measurement_data.proto (DatapointAggregationProto.Grouping)
 */
export enum MeasurementAggregationGrouping {
  Day = 'DAY',
  GroupingUnknown = 'GROUPING_UNKNOWN',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type MeasurementData = BloodGlucoseData | LessonsData | MealData | MedicationData | MoodData | StepsData | WaterData | WeightData;

export type MeasurementDataInput = {
  bloodGlucoseData?: InputMaybe<BloodGlucoseDataInput>;
  lessonsData?: InputMaybe<LessonsDataInput>;
  medicationData?: InputMaybe<MedicationDataInput>;
  /**  TODO: mealData: MealDataInput - too complex for to implement now */
  moodData?: InputMaybe<MoodDataInput>;
  stepsData?: InputMaybe<StepsDataInput>;
  waterData?: InputMaybe<WaterDataInput>;
  weightData?: InputMaybe<WeightDataInput>;
};

export type MeasurementDataList = {
  __typename?: 'MeasurementDataList';
  measurements: Array<MeasurementDataOneOf>;
};

export type MeasurementDataOneOf = {
  __typename?: 'MeasurementDataOneOf';
  bloodGlucoseData?: Maybe<BloodGlucoseData>;
  lessonsData?: Maybe<LessonsData>;
  mealData?: Maybe<MealData>;
  medicationData?: Maybe<MedicationData>;
  moodData?: Maybe<MoodData>;
  stepsData?: Maybe<StepsData>;
  waterData?: Maybe<WaterData>;
  weightData?: Maybe<WeightData>;
};

export enum MeasurementSnapshotStyle {
  Default = 'DEFAULT',
  Prominent = 'PROMINENT'
}

/**
 *  These values should be aligned with:
 *  - measurement_type.proto (MeasurementTypeProto.Id)
 */
export enum MeasurementType {
  BloodGlucose = 'BLOOD_GLUCOSE',
  Lessons = 'LESSONS',
  Meal = 'MEAL',
  Medication = 'MEDICATION',
  Mood = 'MOOD',
  Steps = 'STEPS',
  Unknown = 'UNKNOWN',
  Water = 'WATER',
  Weight = 'WEIGHT'
}

export type MeasurementsData = {
  __typename?: 'MeasurementsData';
  measurements: Array<MeasurementData>;
};

export type MeasurementsDataInput = {
  measurements: Array<MeasurementDataInput>;
};

/**  Medication that is available to the user for logging. */
export type Medication = {
  __typename?: 'Medication';
  /** Medication dose options */
  doseOptions: Array<MedicationDoseOption>;
  /** Medication info: external_id, name, image_url */
  medication: MedicationInfo;
  /** The list of potential side-effects for this medication */
  potentialSideEffects: Array<MedicationSideEffect>;
};

export type MedicationData = {
  __typename?: 'MedicationData';
  dose: Scalars['Float']['output'];
  measurementCivilDateTime: Scalars['LocalDateTime']['output'];
  medicationExternalId: Scalars['String']['output'];
  sideEffects: Array<Scalars['ID']['output']>;
  unit: DoseUnits;
};

export type MedicationDataInput = {
  dose: Scalars['Float']['input'];
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
  medicationExternalId: Scalars['String']['input'];
  sideEffects: Array<Scalars['ID']['input']>;
  unit: DoseUnits;
};

/**  Dose option - each unit could have multiple strengths. */
export type MedicationDoseOption = {
  __typename?: 'MedicationDoseOption';
  /** Available dose strengths */
  doses: Array<Scalars['Float']['output']>;
  /** Dose option unit */
  unit: DoseUnits;
};

export type MedicationGoalMetadata = {
  __typename?: 'MedicationGoalMetadata';
  externalMedicationId?: Maybe<Scalars['String']['output']>;
};

/**  Information about a medication identified by external Id. */
export type MedicationInfo = {
  __typename?: 'MedicationInfo';
  /** External id of the medication */
  medicationExternalId: Scalars['String']['output'];
  /** URL of the image representing the medication */
  medicationImageUrl: Scalars['String']['output'];
  /** Human readable medication name */
  medicationName: Scalars['String']['output'];
};

/**  List of medications available to the user for logging. */
export type MedicationList = {
  __typename?: 'MedicationList';
  /** List of available medications */
  medications: Array<Medication>;
};

export type MedicationPayload = {
  __typename?: 'MedicationPayload';
  medicationName: Scalars['String']['output'];
};

/**  A model wrapping a potential side-effect with ID and display name. */
export type MedicationSideEffect = {
  __typename?: 'MedicationSideEffect';
  /** The string to be used in UI-related features when showing this side-effect */
  displayName: Scalars['String']['output'];
  /** The id of the side-effect */
  id: Scalars['ID']['output'];
};

/** Payload added to Medication Tracker Assignments */
export type MedicationTrackerPayload = {
  __typename?: 'MedicationTrackerPayload';
  /** Status that drives UI state of the task card */
  doseStatus: MedicationTrackerStatus;
  /** The date on or after which we can reuse the last logged weight */
  earliestAcceptedWeightDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Whether the user has ever logged this type of medication before */
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use title and subTitle */
  lastScheduledDoseDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** @deprecated Use title and subTitle */
  lastTakenDoseDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** @deprecated Use title and subTitle */
  lastTakenDoseStrength?: Maybe<Scalars['Float']['output']>;
  /**
   *  DoseUnits comes from measurements/medication.graphqls
   * @deprecated Use title and subTitle
   */
  lastTakenDoseUnit?: Maybe<DoseUnits>;
  /** Whether to present the SmartDose flow on this medication */
  smartDoseFlowEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Subtitle of the task card */
  subTitle: Scalars['String']['output'];
  /** Title of the task card */
  title: Scalars['String']['output'];
};

export enum MedicationTrackerStatus {
  LastDoseMissed = 'LAST_DOSE_MISSED',
  LastDoseTaken = 'LAST_DOSE_TAKEN',
  /** @deprecated Abandoned */
  NextDoseUpcoming = 'NEXT_DOSE_UPCOMING'
}

/** Experiment information */
export type MeristemExperimentInfo = {
  /** The context for this experiment */
  context?: InputMaybe<Scalars['String']['input']>;
  /** The experiment name */
  experimentName?: InputMaybe<Scalars['String']['input']>;
  /** The SHA the user is accessing for this context */
  sha?: InputMaybe<Scalars['String']['input']>;
  /** The name of the arm the user is in */
  variationName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents an amount of money with its currency type.
 * Modeled after MoneyProto in money.proto.
 */
export type Money = {
  __typename?: 'Money';
  /** The three-letter currency code defined in ISO 4217. */
  currencyCode: Scalars['String']['output'];
  /**
   * Number of nano (10^-9) units of the amount.
   * Defaults to 0 if null.
   * The value must be between -999,999,999 and +999,999,999 inclusive.
   * If `units` is positive, `nanos` must be positive or zero.
   * If `units` is zero, `nanos` can be positive, zero, or negative.
   * If `units` is negative, `nanos` must be negative or zero.
   * For example:
   *   - $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
   *   - $99.99 is represented as `units`=99 and `nanos`=990,000,000.
   *   - $5.00  is represented as `units`=5  and `nanos`=0.
   */
  nanos?: Maybe<Scalars['Int']['output']>;
  /**
   * The whole units of the amount.
   * For example if `currencyCode` is `"USD"`, then 1 unit is one US dollar.
   */
  units: Scalars['Int']['output'];
};

export type MoodData = {
  __typename?: 'MoodData';
  measurementCivilDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  moodLevel: Scalars['Int']['output'];
};

export type MoodDataInput = {
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
  moodLevel: Scalars['Int']['input'];
};

export type MultiDayAssignment = {
  __typename?: 'MultiDayAssignment';
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptExternalCoachingTermsAndConditions: ExternalCoachingTermsAndConditionsInfo;
  acknowledgeCoachUserAnnouncement: CoachAnnouncementUserInteraction;
  /**
   * Apply a workflow action to a curriculum object.
   * - `actionInput`: Input containing the action type, object ID and object type
   * Returns the updated editor actions details after applying the workflow action
   */
  applyWorkflowAction: CurriculumEditorActionsDetails;
  /**
   * Updates a user's SmartDose table as needed, returns current SmartDose.
   * May be null if the user hasn't logged medications before.
   */
  calculateSmartDose?: Maybe<SmartDose>;
  createCoachAnnouncement: CoachAnnouncement;
  /** Retrieves the Decagon signature token for a user identified by their access code */
  createDecagonSignatureToken: DecagonSignatureToken;
  /** Creates a partner mapping for the user if one doesn't exist and returns the (existing|new) mapping. */
  createPartnerMappingIfNotExists: PartnerMapping;
  /**
   * Create a program foundation.
   * - `programConfigId`: Required id of the program this foundation is being added to
   * - `foundation`: the input required to create the foundation
   * Returns the newly created foundation
   */
  createProgramFoundation: ProgramFoundation;
  /** Deletes the specified body scan for a user */
  deleteBodyScan: BodyScanDeletionResponse;
  deleteCoachAnnouncement: Scalars['Boolean']['output'];
  /**
   * Delete a program foundation.
   * - `programConfigId`: the UUID of the program this foundation is in
   * - `foundationId`: the UUID of the foundation to delete
   * Returns `true` if the deletion was successful (status code `204`)
   */
  deleteProgramFoundation: Scalars['Boolean']['output'];
  /** Dismisses customer satisfaction survey of the given type on behalf of the user */
  dismissCsatSurvey?: Maybe<CsatSurvey>;
  /** Placeholder field */
  empty?: Maybe<Scalars['ID']['output']>;
  expireCoachAnnouncement: CoachAnnouncement;
  /** Generates a pair of auth/refresh tokens used to access facial blood scan partner API */
  generateApiToken: FacialBloodScanToken;
  /** Initializes a new body scan for the user, and returns the URL which the client should use to upload the body scan data */
  initializeBodyScan: BodyScanUploadMetadata;
  markCoachAnnouncementsView: CoachAnnouncementUserInteractions;
  /** Mark standalone content as consumed */
  markStandaloneContentConsumed: MarkStandaloneContentConsumedResponse;
  /**
   * Called whenever the user opens the mealbot channel. This calls a CS endpoint that triggers actions such as
   * sending a welcome message in the chat.
   * Using a boolean as a response, since GQL doesn't support void responses.
   */
  mealbotChatChannelOpened?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Processes a gamification action with the provided data
   * This can update the system state for various gamification elements like rewards or streaks, and return gamification celebrations to be displayed on the client.
   */
  processGamificationAction: GamificationActionResult;
  /** Updates user body scan settings with provided mode to be used */
  setBodyScanModeSetting: SetBodyScanModeSettingResponse;
  /**
   * Enables or disables out-of-range blood glucose alerts for a user.
   * Returns the new state (true if enabled, false if disabled).
   */
  setOutOfRangeBloodGlucoseAlerts: Scalars['Boolean']['output'];
  /** Updates user show avatar settings with provided boolean value */
  setShowAvatarSetting: SetShowAvatarSettingResponse;
  /**
   * This method is no longer supported and should be removed, but we can't until we allow for exceptions to schema checks
   * @deprecated Use toolsState to patch the state of a tool
   */
  setToolPinState: ToolId;
  submitConsent?: Maybe<Scalars['Boolean']['output']>;
  /** Submits a completed customer satisfaction survey on behalf of the user */
  submitCsatSurvey?: Maybe<CsatSurvey>;
  /** Records the user's response to the specified policy */
  submitPolicyOption: UserPolicyOption;
  /** Patches the new state for one or more tools, and returns the full state, updated, of all the tools of the user and program */
  toolsState: ToolList;
  /**
   * Notify the backend that the image has been uploaded and it can start processing.
   * GQL doesn’t support void responses, so returning an object in case we want to
   * extend it in the future
   */
  triggerFaceScanProcessing?: Maybe<TriggerFaceScanResponse>;
  updateCoachAnnouncement: CoachAnnouncement;
  updateCommunityHintInterstitialState: InterstitialState;
  /** Updates dynamic calorie goal settings for a user. */
  updateDynamicCalorieGoalSettingsState: DynamicCalorieGoalSettingsState;
  /** Updates a user's goal in GoalsAPI for a user and program. */
  updateGoal: UserGoal;
  updateInterstitial: InterstitialState;
  updateMacroMonitoringSettingsState: MacroMonitoringSettingsState;
  /**
   * Update the foundation.
   * - `programConfidId`: Required id of this foundation's parent program
   * - `foundationId`: Required id of the foundation to update
   * - `foundation`: The input required to update the foundation
   * Returns the updated foundation
   */
  updateProgramFoundation: ProgramFoundation;
  /**
   * Update the ordering of Foundations within a Program. The order of the foundation IDs in the provided list
   * determines the order of the Foundations within the Program.
   * - `programConfigId`: the id of the program the foundations belong to
   * - `foundationIds`: an *ordered* list of foundation ids;
   * Returns true if the update succeeded.
   */
  updateProgramFoundationOrder?: Maybe<Scalars['Boolean']['output']>;
  updateSuccessKitIntroInterstitialState: InterstitialState;
  /** Updates user birth date and returns it back on success. */
  updateUserDateOfBirth: Scalars['LocalDate']['output'];
  /** Stores a measurement by proxying the request to the measurement-api. */
  upsertMeasurement: MeasurementData;
  /** Stores a measurements by proxying the request to the measurement-api. */
  upsertMeasurements: MeasurementsData;
  /**  Create or update settings for a specific reminder */
  upsertReminderSettings: ReminderSettings;
};


export type MutationAcceptExternalCoachingTermsAndConditionsArgs = {
  accessCode: Scalars['String']['input'];
  externalCoachingTermsAndConditionsInput: ExternalCoachingTermsAndConditionsInput;
};


export type MutationAcknowledgeCoachUserAnnouncementArgs = {
  coachUserAnnouncementId: Scalars['String']['input'];
};


export type MutationApplyWorkflowActionArgs = {
  actionInput: CurriculumWorkflowActionInput;
};


export type MutationCalculateSmartDoseArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDateTime: Scalars['LocalDateTime']['input'];
};


export type MutationCreateCoachAnnouncementArgs = {
  coachAnnouncementInput: CoachAnnouncementInput;
};


export type MutationCreateDecagonSignatureTokenArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationCreatePartnerMappingIfNotExistsArgs = {
  accessCode: Scalars['String']['input'];
  partnerSlug: PartnerSlug;
};


export type MutationCreateProgramFoundationArgs = {
  foundation: ProgramFoundationInput;
  programConfigId: Scalars['UUID']['input'];
};


export type MutationDeleteBodyScanArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  scanUuid: Scalars['UUID']['input'];
};


export type MutationDeleteCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type MutationDeleteProgramFoundationArgs = {
  foundationId: Scalars['UUID']['input'];
  programConfigId: Scalars['UUID']['input'];
};


export type MutationDismissCsatSurveyArgs = {
  surveyInput: DismissCsatSurveyInput;
};


export type MutationExpireCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type MutationGenerateApiTokenArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  tokenInput: FacialBloodScanTokenInput;
};


export type MutationInitializeBodyScanArgs = {
  accessCode: Scalars['String']['input'];
  clientCivilDatetime: Scalars['LocalDateTime']['input'];
  mode?: InputMaybe<BodyScanMode>;
  scanDevice: TargetPlatform;
  sex?: InputMaybe<Sex>;
  weightInKg: Scalars['Float']['input'];
};


export type MutationMarkCoachAnnouncementsViewArgs = {
  coachUserAnnouncementIds: Array<Scalars['String']['input']>;
};


export type MutationMarkStandaloneContentConsumedArgs = {
  input: MarkStandaloneContentConsumedInput;
};


export type MutationMealbotChatChannelOpenedArgs = {
  channelURL: Scalars['String']['input'];
  userAccessCode: Scalars['String']['input'];
};


export type MutationProcessGamificationActionArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  data: GamificationActionDataInput;
};


export type MutationSetBodyScanModeSettingArgs = {
  accessCode: Scalars['String']['input'];
  mode: BodyScanMode;
};


export type MutationSetOutOfRangeBloodGlucoseAlertsArgs = {
  accessCode: Scalars['String']['input'];
  alertsEnabled: Scalars['Boolean']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type MutationSetShowAvatarSettingArgs = {
  accessCode: Scalars['String']['input'];
  showAvatar: Scalars['Boolean']['input'];
};


export type MutationSetToolPinStateArgs = {
  accessCode: Scalars['String']['input'];
  pinStateInput: SetToolPinStateInput;
  programUuid: Scalars['UUID']['input'];
};


export type MutationSubmitConsentArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  agreedToPolicies: Array<Policy>;
};


export type MutationSubmitCsatSurveyArgs = {
  surveyInput: SubmitCsatSurveyInput;
};


export type MutationSubmitPolicyOptionArgs = {
  accessCode: Scalars['String']['input'];
  consentStatus: PolicyOptionStatus;
  policy: Policy;
  signature?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToolsStateArgs = {
  accessCode: Scalars['String']['input'];
  newToolsState: PatchToolsState;
  programUuid: Scalars['UUID']['input'];
};


export type MutationTriggerFaceScanProcessingArgs = {
  scanId: Scalars['UUID']['input'];
};


export type MutationUpdateCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
  coachAnnouncementInput: CoachAnnouncementInput;
};


export type MutationUpdateCommunityHintInterstitialStateArgs = {
  accessCode: Scalars['String']['input'];
  displayDate: Scalars['LocalDate']['input'];
};


export type MutationUpdateDynamicCalorieGoalSettingsStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  activityLevelName?: InputMaybe<ActivityLevelName>;
  externalBmrEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  manualCalorieAdjustment?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateGoalArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  goalPatch: UserGoalPatch;
  programUuid: Scalars['String']['input'];
  userGoalId: Scalars['String']['input'];
};


export type MutationUpdateInterstitialArgs = {
  accessCode: Scalars['String']['input'];
  interstitials: UpdateInterstitialInput;
};


export type MutationUpdateMacroMonitoringSettingsStateArgs = {
  accessCode: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  macroTargets?: InputMaybe<CalorieBudgetMacroTargetsInput>;
};


export type MutationUpdateProgramFoundationArgs = {
  foundation: ProgramFoundationInput;
  foundationId: Scalars['UUID']['input'];
  programConfigId: Scalars['UUID']['input'];
};


export type MutationUpdateProgramFoundationOrderArgs = {
  foundationIds: Array<Scalars['UUID']['input']>;
  programConfigId: Scalars['UUID']['input'];
};


export type MutationUpdateSuccessKitIntroInterstitialStateArgs = {
  accessCode: Scalars['String']['input'];
  displayDate: Scalars['LocalDate']['input'];
};


export type MutationUpdateUserDateOfBirthArgs = {
  accessCode: Scalars['String']['input'];
  birthDate: Scalars['LocalDate']['input'];
  clientCivilDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type MutationUpsertMeasurementArgs = {
  accessCode: Scalars['String']['input'];
  attribution?: InputMaybe<AttributionDataInput>;
  clientCivilDateTime: Scalars['LocalDateTime']['input'];
  data: MeasurementDataInput;
};


export type MutationUpsertMeasurementsArgs = {
  accessCode: Scalars['String']['input'];
  attribution?: InputMaybe<AttributionDataInput>;
  clientCivilDateTime: Scalars['LocalDateTime']['input'];
  data: MeasurementsDataInput;
};


export type MutationUpsertReminderSettingsArgs = {
  accessCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  reminderSubtype: Scalars['String']['input'];
  reminderTime: Scalars['LocalTime']['input'];
  reminderType: ReminderType;
  reminderUuid: Scalars['UUID']['input'];
};

/** Content for a button in the top nav. */
export type NavigationButtonContent = {
  __typename?: 'NavigationButtonContent';
  /** The text of the CTA button. */
  buttonText: Scalars['String']['output'];
  /** The url that should be opened when the ad is tapped. */
  targetUrl: Scalars['String']['output'];
};

export type NoomAppAttributionDataInput = {
  sourceIdentifier: Scalars['String']['input'];
};

/**
 *  These values should be aligned with:
 *  - macros.proto (NutritionBreakdownProto)
 */
export type NutritionBreakdown = {
  __typename?: 'NutritionBreakdown';
  carbohydrateMg?: Maybe<Scalars['Float']['output']>;
  dietaryFiberMg?: Maybe<Scalars['Float']['output']>;
  potassiumMg?: Maybe<Scalars['Float']['output']>;
  proteinMg?: Maybe<Scalars['Float']['output']>;
  sodiumMg?: Maybe<Scalars['Float']['output']>;
  totalFatMg?: Maybe<Scalars['Float']['output']>;
};

export type Pageable = {
  /** Metadata for fetching the next page of results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** The total number of results that match the filtering criteria for the returned list */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**  Encapsulates a partner + partner user id mapping for a user. */
export type PartnerMapping = {
  __typename?: 'PartnerMapping';
  partnerSlug: PartnerSlug;
  partnerUserId: Scalars['String']['output'];
};

/**
 *  Supported partners that we store external user ids for.
 *  Keep in sync with user_partner_mapping.proto
 */
export enum PartnerSlug {
  MdIntegrations = 'MD_INTEGRATIONS',
  Sendbird = 'SENDBIRD',
  Singular = 'SINGULAR',
  SteadyMd = 'STEADY_MD',
  Zumba = 'ZUMBA'
}

export type PastMedicationDose = {
  __typename?: 'PastMedicationDose';
  /** Dose strength */
  dose: Scalars['Float']['output'];
  /** Medication info: external_id, name, image_url */
  medication: MedicationInfo;
  /** Side-effects */
  sideEffects: Array<MedicationSideEffect>;
  /** When the medication was taken */
  takenOn: Scalars['LocalDateTime']['output'];
  /** Dose units */
  unit: DoseUnits;
};

/**  Past medication doses that user has taken */
export type PastMedicationDoseList = {
  __typename?: 'PastMedicationDoseList';
  /** Metadata for fetching the next page of past medication doses, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** List of past medication doses */
  pastDoses: Array<PastMedicationDose>;
};

export type PatchToolsState = {
  toolsStatesPatch: Array<ToolStatePatch>;
};

export type PatientDiagnosticReportList = {
  __typename?: 'PatientDiagnosticReportList';
  /** List of user's diagnostic reports, in reverse order of time collected */
  patientDiagnosticReports: Array<PatientDiagnosticReportMetadata>;
};

/** Encapsulates the data for a single diagnostic report */
export type PatientDiagnosticReportMetadata = {
  __typename?: 'PatientDiagnosticReportMetadata';
  /** AI summary of the diagnostic report result, only for the latest result */
  aiSummary?: Maybe<Scalars['String']['output']>;
  /** URL of the diagnostic report */
  diagnosticReportUrl: Scalars['String']['output'];
  /** Unique identifier of the diagnostic report */
  id: Scalars['String']['output'];
  /** Time at which the diagnostic was performed on the user */
  timeCollected: Scalars['LocalDateTime']['output'];
};

/** A resource in the plateau resources screen. */
export type PlateauResource = {
  __typename?: 'PlateauResource';
  /** Button associated with this resource. */
  button: Button;
  /** URL of the image for this resource. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Title of this plateau resource. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 *  Naming convention is the state/province (if applicable) underscore the
 *  recognized acronym for the act. Since the acronym can often be confusing,
 *  prefixing with the state makes it clearer where the policy is applicable.
 */
export enum Policy {
  CaCcpa = 'CA_CCPA',
  CoCpa = 'CO_CPA',
  /**
   *  Value representing the CTDPA before it was amended by S.B. 3 (below). The
   *  old value will still be returned by reads, but shouldn't be used in new
   *  policy option writes.
   */
  CtCtdpa = 'CT_CTDPA',
  /**
   *  Connecticut S.B. 3 amended the CTDPA, increasing its breadth and causing
   *  it to apply to an account rather than just an email address.
   */
  CtSb3 = 'CT_SB3',
  /**
   *  This handles users who have opted out, but for whatever reason we are not
   *  sure from where. Largely this will contain users from before we started
   *  keeping track.
   */
  General = 'GENERAL',
  NoomB2BPp = 'NOOM_B2B_PP',
  NoomB2CPp = 'NOOM_B2C_PP',
  NoomHipaaNotice = 'NOOM_HIPAA_NOTICE',
  NoomLiabilityWaiver = 'NOOM_LIABILITY_WAIVER',
  /**  Noom internal policies */
  NoomTos = 'NOOM_TOS',
  NvSb370 = 'NV_SB370',
  /**
   *  Patient Restriction on Medicare Claim Submition Terms. Allow us to keep
   *  track when patient is presented this terms to indicate he can't bill
   *  medicare (US Only)
   */
  UsPrmcst = 'US_PRMCST',
  UtUcpa = 'UT_UCPA',
  VaVcdpa = 'VA_VCDPA',
  WaMhmd = 'WA_MHMD'
}

/**  Please keep in-sync with StatusEnumProto */
export enum PolicyOptionStatus {
  Agree = 'AGREE',
  NotNeeded = 'NOT_NEEDED',
  OptInMayShare = 'OPT_IN_MAY_SHARE',
  OptOutDoNotShare = 'OPT_OUT_DO_NOT_SHARE'
}

/**
 *  These values should be aligned with:
 *  - food.proto (PortionProto)
 */
export type Portion = {
  __typename?: 'Portion';
  quantity: Scalars['Float']['output'];
  totalCalories?: Maybe<Scalars['Float']['output']>;
  unitName: Scalars['String']['output'];
  unitType: PortionUnitType;
};

export enum PortionUnitType {
  Easy = 'EASY',
  Precise = 'PRECISE',
  Unknown = 'UNKNOWN'
}

export enum PreferredWeightUnit {
  Kg = 'KG',
  Lb = 'LB',
  Stone = 'STONE'
}

export type PrismBodyScanAttributionDataInput = {
  /** Prism body scan identifier. */
  bodyScanUuid: Scalars['String']['input'];
};

/** Definition of a Foundation within a program */
export type ProgramFoundation = {
  __typename?: 'ProgramFoundation';
  /** An optional description of the foundation */
  description?: Maybe<Scalars['String']['output']>;
  /** Which actions a curriculum editor can take on this object */
  editorActionDetails: CurriculumEditorActionsDetails;
  /** The id of the foundation */
  id: Scalars['UUID']['output'];
  /** Foundation metadata */
  metadata: ProgramFoundationMetadata;
  /** An ordered list of module objects. Only included if explicity requested */
  modules?: Maybe<Array<CurriculumModule>>;
  /** Foundation name */
  name: Scalars['String']['output'];
  /** The ID of the program this foundation belongs to */
  programConfigId: Scalars['UUID']['output'];
  /** The user segment ids that defines who this foundation applies to */
  userSegmentation?: Maybe<ProgramFoundationUserSegmentation>;
};

export type ProgramFoundationInput = {
  /** An optional description to give this foundation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ordered list of module IDs for this foundation */
  moduleIds: Array<Scalars['UUID']['input']>;
  /** The name to give the foundation */
  name: Scalars['String']['input'];
  /** User segmentation ids and operator defining membership to this foundation */
  userSegmentation?: InputMaybe<ProgramFoundationUserSegmentationInput>;
};

export type ProgramFoundationMetadata = {
  __typename?: 'ProgramFoundationMetadata';
  /** User details of the user that created this foundation */
  createdBy: ProgramFoundationUserDetails;
  /** The date and time this foundation was first created */
  createdOn: Scalars['LocalDateTime']['output'];
  /** Whether or not this foundation has unpublished (i.e. draft) changes */
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  /** Whether or not this foundation is in a published state */
  isLive: Scalars['Boolean']['output'];
  /** User details of the user that most recently modified the foundation */
  updatedBy: ProgramFoundationUserDetails;
  /** The date and time this foundation was most recently modified */
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type ProgramFoundationUserDetails = {
  __typename?: 'ProgramFoundationUserDetails';
  /** The first name of the user that created this foundation */
  firstName: Scalars['String']['output'];
  /** The last name of the user that created this foundation */
  lastName?: Maybe<Scalars['String']['output']>;
};

/** The segment IDs and logical operator defining how to evaluate the user against those segments */
export type ProgramFoundationUserSegmentation = {
  __typename?: 'ProgramFoundationUserSegmentation';
  /** The segment ids */
  ids: Array<Scalars['ID']['output']>;
  /** The logical operator defining how the segment ids should be evaluated with eachother */
  operator: ProgramFoundationUserSegmentationOperator;
};

/** Inputs for defining the user segmentation for the foundation */
export type ProgramFoundationUserSegmentationInput = {
  /** The usermodel segment ids */
  ids: Array<Scalars['ID']['input']>;
  /** The operator/condition defining how the segment ids should be evaluated together */
  operator: ProgramFoundationUserSegmentationOperator;
};

/** User segmentation operators defining how segments should be evaluated together */
export enum ProgramFoundationUserSegmentationOperator {
  /** The user must belong to each segment represented in the list */
  And = 'AND',
  /** The user must belong to at least one of the segments in the list */
  Or = 'OR'
}

export type ProgramFoundations = {
  __typename?: 'ProgramFoundations';
  foundations: Array<ProgramFoundation>;
};

/** This is a superclass for other possible future configurations */
export type ProviderConfiguration = AnuraConfiguration;

export type Query = {
  __typename?: 'Query';
  /**
   * Gets an AI meal insight for the user with their most recently logged meal as input.
   * @deprecated Use the mealInsight query instead.
   */
  aiMealInsight: AiMealInsight;
  /**
   * Returns the information needed by the client to draw a chart with the specified measurements and annotations.
   * - fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   * future measurements) are unbounded
   * - Chronological or reverse chronological order is provided by the "from" and "to" dates: if "from" is earlier than "to",
   * then it will be in chronological order; and if "to" is earlier than "from", it will go in reverse chronological order
   * - You can also optionally limit by a maximum number of measurements and/or maximum number of annotations. Whatever
   * is reached earlier will set the limit of the graph, and no further measurements or annotations beyond those
   * will be provided (e.g. if we limit to 10 annotations, and the 10th annotation happens on a certain date, then no
   * annotations or measurements will be provided beyond that date, even if we still had a larger limit of
   * measurements). If not provided, they are each limited to 100. The maximum limit accepted is 500: if a higher
   * limit is provided, it will be ignored and 500 will be used. We still don't provide any mechanism for pagination,
   * so if you need more elements than that, please reach out to the Program Content team!
   */
  annotatedMeasurementTrendChart: AnnotatedMeasurementTrendChart;
  /** Informs the client what all data points (if any) need to be gathered from the user when they enter the body scan feature */
  bodyScanIngress: BodyScanIngressChecks;
  /** Returns the applicable privacy policy for a user using the body scan feature */
  bodyScanPrivacyPolicy: Policy;
  /** Returns body scan settings for a given user */
  bodyScanSettings: BodyScanSettingsResponse;
  /** Returns the state of the user's active body scan at the given instant, or defaults to the current instant if none provided. */
  bodyScanTrackerState: BodyScanTrackerState;
  /** Returns a list of body scans for the user */
  bodyScans: BodyScanList;
  /** Queries a chat channel by id */
  chatChannel?: Maybe<ChatChannel>;
  /** Get the channel url for the clinician chat. */
  clinicianChannelUrl?: Maybe<Scalars['String']['output']>;
  /** Get one announcement */
  coachAnnouncement?: Maybe<CoachAnnouncement>;
  /** Get a list of announcements. The sorting order is the backend default */
  coachAnnouncements?: Maybe<CoachAnnouncementsResult>;
  coachAnnouncementsUserInteractions: CoachAnnouncementUserInteractionsPaged;
  coachAnnouncementsUserInteractionsInfo: CoachAnnouncementsUserInteractionInfo;
  /** Configs used by the coaching area */
  coachingConfig?: Maybe<CoachingConfig>;
  /** Checks if the user needs to (re)accept any agreements */
  consentCheck: UserConsentCheck;
  /** Returns modules that can be used to build a curriculum. */
  curriculumModules: CurriculumModules;
  /**
   * Returns all curricular programs with an optional list of modules that belong
   * to programs.
   *
   * Clients can control the results to be more or less granular using the provided filters.
   */
  curriculumPrograms: CurriculumPrograms;
  /** Returns the dynamic calorie goal settings for a user. */
  dynamicCalorieGoalSettingsState: DynamicCalorieGoalSettingsState;
  /** Returns whether the user is eligible to be displayed the WeightMedsSnapshot, depending on their med logging data */
  eligibleForWeightMedsSnapshot: Scalars['Boolean']['output'];
  /**
   * Returns whether the user is eligible to be displayed the WeightMedsSnapshot, depending on whether they have
   * the goal enabled for the appropriate Meds
   */
  eligibleForWeightMedsSnapshotBasedOnGoals: Scalars['Boolean']['output'];
  /** Placeholder field */
  empty?: Maybe<Scalars['ID']['output']>;
  /** This endpoint return all mandatory documents that are signed during NMC enrolment */
  externalCoachingTermsAndConditions: ExternalCoachingTermsAndConditionsInfo;
  /** Gets sections of fixed content for a user */
  fixedContentSections: Array<FixedContentSection>;
  /** Returns the UserGoals for a user and program. */
  goalsForDate: UserGoalList;
  homeScreenCarouselState: HomeScreenCarouselState;
  /** Returns home screen navigation configuration */
  homeScreenNavigation: HomeScreenNavigation;
  /** Request a presigned S3 link to upload the face image for further processing */
  initializeFaceScan: FaceScanInitializationInfo;
  interstitials: Interstitials;
  macroMonitoringSettingsState: MacroMonitoringSettingsState;
  /** Gets an meal insight for the user with their most recently logged meal as input. */
  mealInsight?: Maybe<AiInsight>;
  /** Query for telling the client what meal logging method selector options are available */
  mealLoggingMethodSelectorFeatureState: MealLoggingMethodSelectorFeatureState;
  /**
   * Fetches the latest state of measurements for a given access code and measurement type, replicating what the
   * `measurementDataList` subscription, but as a one-time query.
   *
   * Similar to the subscription, this query returns data points within the given time range
   * (fromCivilDateTime to toCivilDateTime), if provided. If no range is specified, the query will return all
   * available data up to the maximum limit (default max is 1000). The 'limit' parameter restricts the number
   * of returned results and is useful for controlling payload size. Data is returned in ascending or descending
   * order based on the 'ascendingOrder' flag.
   *
   * Note: Pagination is not currently supported. If you require more than 1000 data points in a single request,
   * please reach out to TNG to discuss enabling pagination support.
   */
  measurementDataList: MeasurementDataList;
  /** List of medications that user needs to take for on the given date. */
  medicationList: MedicationList;
  /**
   * The current state of the out-of-range blood glucose alerts for a user.
   * True if the alerts are enabled, or false if they are disabled.
   */
  outOfRangeBloodGlucoseAlertsEnabled: Scalars['Boolean']['output'];
  /** Returns a list of past medication doses. */
  pastMedicationDoseList: PastMedicationDoseList;
  /** Returns the list of user's diagnostic reports, in reverse order of time collected */
  patientDiagnosticReports: PatientDiagnosticReportList;
  /**
   * Return a single foundation.
   * - `programConfigId`: Required id of the foundation's parent program
   * - `foundationId`: Required id of the foundation to fetch
   * Returns the foundation
   */
  programFoundation: ProgramFoundation;
  /**
   * Return all program foundations
   * - `programConfigId`: Required id of the program to fetch all foundations for
   * Returns the list of foundations
   */
  programFoundations: ProgramFoundations;
  /** Returns partner specific set of parameters for initiating a facial blood scan */
  providerConfiguration: ProviderConfiguration;
  /** Get a recommended offer for a user going through the buyflow. Initially this will only be used for med plan reveal. */
  recommendedBuyflowOffers: RecommendedBuyflowOffersResponse;
  /**  Return a list of all reminders for a given user and reminder type */
  reminderSettingsState: ReminderSettingsList;
  /**
   * Returns info on the user's rewards, e.g. current state, program configuration, etc.
   * Called by the client on app launch.
   */
  rewards: Rewards;
  /**
   * Returns a list of available rewards levels.
   * Called by the client when the Rewards screen is opened.
   */
  rewardsLevels: RewardsLevels;
  /**
   * Fetches a user's current SmartDose for the user's prescribed medication.
   * May be null if the user hasn't logged medications before.
   */
  smartDose?: Maybe<SmartDose>;
  /** Returns the details of the streak */
  streakDetails?: Maybe<Streak>;
  streakFreeze?: Maybe<StreakFreeze>;
  /** Retrieves the support chat unread messages count for a user identified by their access code */
  supportChatUnreadMessages: SupportChatUnreadMessages;
  /** Returns successfully if x-noom-config-ref, x-noom-routing-id, and Accept-Language are successfully proxied */
  testHeaderProxying?: Maybe<Scalars['String']['output']>;
  /** Returns the access code parameter if present, otherwise attempts to determine the access code from the token. */
  testOptionalAccessCode: Scalars['String']['output'];
  /** Returns `Looking good!` */
  testSuccess?: Maybe<Scalars['String']['output']>;
  /** Returns an unauthorized API response */
  testUnauthorized?: Maybe<Scalars['String']['output']>;
  /** Returns a list of upcoming medication doses. */
  upcomingMedicationDoseList: UpcomingMedicationDoseList;
  /** Returns a list of data required by the client for upsell ad placement */
  upsellAdDataList: UpsellAdDataList;
  /**
   * Search for user model segments using any of the supported search fields.
   *
   * The query exposes pagination via CursorPagination, but the only implemented
   * field is 'first'. You can specify how many search results you want, but
   * you can't sort them or define which page you want to retrieve.
   *
   * All fields except for 'first' are unsupported now, but might be supported in
   * the future. So, if you're using pagination, use sensible values even for
   * unsupported fields to avoid unwanted behavior if and when EC-API rolls
   * out full pagination support.
   */
  userModelSegments?: Maybe<UserModelSegments>;
  /**
   * Returns a specific version of the AnnotatedMeasurementTrendChart using Weight as measurement and Meds as annotation.
   * The response also includes some information specific to this chart. The limits are determined by the product
   * requirements - we should return all weight measurements occurring within the last three med logs for
   * semaglutide users. For other med users this endpoint should return no data.
   */
  weightMedsSnapshot: WeightMedsSnapshot;
};


export type QueryAiMealInsightArgs = {
  analyticsConversationId?: InputMaybe<Scalars['String']['input']>;
  loggedMealInput: LoggedMealInput;
};


export type QueryAnnotatedMeasurementTrendChartArgs = {
  accessCode: Scalars['String']['input'];
  annotationType?: InputMaybe<TrendChartAnnotationType>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limitAnnotations?: InputMaybe<Scalars['Int']['input']>;
  limitMeasurements?: InputMaybe<Scalars['Int']['input']>;
  measurementType: TrendChartMeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type QueryBodyScanIngressArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryBodyScanPrivacyPolicyArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBodyScanSettingsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryBodyScanTrackerStateArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


export type QueryBodyScansArgs = {
  accessCode: Scalars['String']['input'];
  filters?: InputMaybe<BodyScansListFilters>;
  pagination?: InputMaybe<CursorPagination>;
};


export type QueryChatChannelArgs = {
  channelId: Scalars['String']['input'];
};


export type QueryClinicianChannelUrlArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type QueryCoachAnnouncementsArgs = {
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type QueryCoachAnnouncementsUserInteractionsArgs = {
  cursorPagination: CursorPagination;
};


export type QueryConsentCheckArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCurriculumModulesArgs = {
  filters?: InputMaybe<CurriculumModulesFilters>;
};


export type QueryDynamicCalorieGoalSettingsStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEligibleForWeightMedsSnapshotArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryEligibleForWeightMedsSnapshotBasedOnGoalsArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryExternalCoachingTermsAndConditionsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFixedContentSectionsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoalsForDateArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  programUuid: Scalars['String']['input'];
};


export type QueryHomeScreenCarouselStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryInitializeFaceScanArgs = {
  age?: InputMaybe<Scalars['Int']['input']>;
  scanId: Scalars['UUID']['input'];
};


export type QueryInterstitialsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryMacroMonitoringSettingsStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryMealInsightArgs = {
  analyticsConversationId?: InputMaybe<Scalars['String']['input']>;
  loggedMealInput: LoggedMealInput;
};


export type QueryMealLoggingMethodSelectorFeatureStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMeasurementDataListArgs = {
  accessCode: Scalars['String']['input'];
  ascendingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measurementType: MeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type QueryMedicationListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryOutOfRangeBloodGlucoseAlertsEnabledArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryPastMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type QueryPatientDiagnosticReportsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryProgramFoundationArgs = {
  foundationId: Scalars['UUID']['input'];
  live?: InputMaybe<Scalars['Boolean']['input']>;
  programConfigId: Scalars['UUID']['input'];
};


export type QueryProgramFoundationsArgs = {
  live?: InputMaybe<Scalars['Boolean']['input']>;
  programConfigId: Scalars['UUID']['input'];
};


export type QueryProviderConfigurationArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  provider: FacialBloodScanProvider;
};


export type QueryRecommendedBuyflowOffersArgs = {
  input: RecommendedBuyflowOffersInput;
};


export type QueryReminderSettingsStateArgs = {
  accessCode: Scalars['String']['input'];
  reminderType: ReminderType;
};


export type QueryRewardsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryRewardsLevelsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QuerySmartDoseArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDateTime: Scalars['LocalDateTime']['input'];
};


export type QueryStreakDetailsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  dataDateRange: LocalDateRangeInput;
  type: StreakType;
  userCurrentDate: Scalars['LocalDate']['input'];
};


export type QueryStreakFreezeArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupportChatUnreadMessagesArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryTestOptionalAccessCodeArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpcomingMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
  programUuid: Scalars['String']['input'];
};


export type QueryUpsellAdDataListArgs = {
  accessCode: Scalars['String']['input'];
  adLocation?: InputMaybe<UpsellAdLocation>;
};


export type QueryUserModelSegmentsArgs = {
  createdAfter?: InputMaybe<Scalars['LocalDateTime']['input']>;
  creator?: InputMaybe<Scalars['String']['input']>;
  creatorsToExclude?: InputMaybe<CreatorsToExclude>;
  cursorPagination?: InputMaybe<CursorPagination>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWeightMedsSnapshotArgs = {
  accessCode: Scalars['String']['input'];
  preferredWeightUnit?: InputMaybe<PreferredWeightUnit>;
};

/** Feedback with just a rating */
export type RatingOnlyInsightFeedback = InsightFeedback & {
  __typename?: 'RatingOnlyInsightFeedback';
  /** The user's rating for the insight */
  rating?: Maybe<InsightFeedbackRating>;
};

/** Feedback with a rating and further comments */
export type RationaleInsightFeedback = InsightFeedback & {
  __typename?: 'RationaleInsightFeedback';
  /** The user's rating for the insight */
  rating?: Maybe<InsightFeedbackRating>;
  /** Comments from the user on why they selected the rating they did */
  rationale?: Maybe<Scalars['String']['output']>;
};

/** Input for getting recommended offers */
export type RecommendedBuyflowOffersInput = {
  /**
   * A list of products the user is eligible to be offered.
   * Long term this will be determined by the backend, but initially we
   * send these from the FE.
   */
  eligibleSKUsForRecommendation?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of contexts the user has encountered with experiment arms and SHAs */
  experiments?: InputMaybe<Array<MeristemExperimentInfo>>;
  /** The type of recommendation we're doing */
  recommendationType: Scalars['String']['input'];
  /** All of the survey answers the user has stored */
  surveyAnswers?: InputMaybe<Array<BuyflowSurveyAnswer>>;
  /** Tracking parameters the user used (ie from the url) */
  trackingParams?: InputMaybe<TrackingParams>;
  /** userId string - matches buyflow db's userdata_userdata.id */
  userId: Scalars['String']['input'];
};

/** Response containing recommended offers */
export type RecommendedBuyflowOffersResponse = {
  __typename?: 'RecommendedBuyflowOffersResponse';
  /** Ordered list of the offers to display; the first one will be displayed on the plans results page, the whole list will be displayed if the user clicks 'See More' */
  offers: Array<Scalars['String']['output']>;
  /** Correlation id of this request */
  recommendationId: Scalars['String']['output'];
};

export type ReminderSettings = {
  __typename?: 'ReminderSettings';
  enabled: Scalars['Boolean']['output'];
  reminderSubtype: Scalars['String']['output'];
  reminderTime: Scalars['LocalTime']['output'];
  reminderType: ReminderType;
  reminderUuid: Scalars['UUID']['output'];
};

export type ReminderSettingsList = {
  __typename?: 'ReminderSettingsList';
  reminderSettings: Array<ReminderSettings>;
};

/**
 *  These values must be aligned with:
 *  - reminder_settings.proto (ReminderTypeProto.Value)
 */
export enum ReminderType {
  Medication = 'MEDICATION',
  Unknown = 'UNKNOWN'
}

/** Represents an image for a reward */
export type RewardImage = {
  __typename?: 'RewardImage';
  /** Type of image */
  image: RewardImageType;
};

/** Reward image asset - this is a wrapper for enum because union types don't allow enums */
export type RewardImageAsset = {
  __typename?: 'RewardImageAsset';
  /** Type of image asset */
  type: RewardImageAssetType;
};

/**
 * Represents available image assets for rewards.
 * In older versions of the app that do not recognize the image asset type, the image will not be shown.
 */
export enum RewardImageAssetType {
  BlueGemstone = 'BLUE_GEMSTONE',
  GreenGemstone = 'GREEN_GEMSTONE',
  PinkGemstone = 'PINK_GEMSTONE',
  PurpleGemstone = 'PURPLE_GEMSTONE',
  RedGemstone = 'RED_GEMSTONE',
  RedGemstoneHeart = 'RED_GEMSTONE_HEART'
}

/**
 * Union of available types of reward images.
 * Currently, we only support local image assets, however, this can be expanded with other types, including URLs for images hosted on the backend.
 * In older versions of the app that do not recognize the image type, depending on where the image is used:
 *     - CurrencyEarnedReward: the reward image will not be shown in the currency earned modal.
 *     - RewardsLevel: the reward level list item will not be shown.
 */
export type RewardImageType = RewardImageAsset;

export type Rewards = {
  __typename?: 'Rewards';
  /** Current state of user's rewards. */
  state: RewardsState;
};

/** Represents a single reward level */
export type RewardsLevel = {
  __typename?: 'RewardsLevel';
  /** Image for the reward level */
  image: RewardImage;
  /** Reward level is permanently unlocked once user reached the required amount */
  isUnlocked: Scalars['Boolean']['output'];
  /** Identifies a specific reward level */
  level: Scalars['Int']['output'];
  /** Required amount of currency to unlock the reward */
  requiredCurrencyAmount: Scalars['Int']['output'];
  /** Type of rewards level */
  type: RewardsLevelType;
};

/** Represents a charity reward level */
export type RewardsLevelCharity = {
  __typename?: 'RewardsLevelCharity';
  /** WebView URL for redeeming the reward */
  redeemWebViewUrl: Scalars['String']['output'];
};

/** Represents a gift card reward level */
export type RewardsLevelGiftCard = {
  __typename?: 'RewardsLevelGiftCard';
  /** WebView URL for redeeming the reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Monetary amount of gift card */
  value: Money;
};

/**
 * Union representing the different types of rewards levels.
 * In older versions of the app that do not recognize the reward level type (or the reward image), the reward level will not be shown.
 */
export type RewardsLevelType = RewardsLevelCharity | RewardsLevelGiftCard;

/** Represents the different rewards levels available to users */
export type RewardsLevels = {
  __typename?: 'RewardsLevels';
  /** Contains info for displaying How to earn currency screen */
  howToEarnCurrency: HowToEarnCurrencyType;
  /** A list of available rewards levels */
  levels: Array<RewardsLevel>;
  /**
   * A list of available methods to earn rewards currency
   * @deprecated Methods are not needed any more
   */
  methods: Array<Maybe<EarnCurrencyMethod>>;
};

/**
 * Union representing the different types of rewards states.
 * In older versions of the app that do not recognize the reward state type, the state update will be ignored.
 */
export type RewardsState = EnrolledRewardsState | UnenrolledRewardsState;

export type SHealthAttributionDataInput = {
  /** Package name of the app inserting data. */
  packageName: Scalars['String']['input'];
  /** Unique identifier for the data point in SHealth. */
  uuid: Scalars['String']['input'];
};

/** A wrapper for the seeds string Content Item description */
export type SeedsString = {
  __typename?: 'SeedsString';
  /** Simple string value */
  value: Scalars['String']['output'];
};

/** Response from a successfully updated body scan mode setting */
export type SetBodyScanModeSettingResponse = {
  __typename?: 'SetBodyScanModeSettingResponse';
  mode: BodyScanMode;
};

/** Response from a successfully updated show avatar setting */
export type SetShowAvatarSettingResponse = {
  __typename?: 'SetShowAvatarSettingResponse';
  showAvatar: Scalars['Boolean']['output'];
};

export type SetToolPinStateInput = {
  pinned: Scalars['Boolean']['input'];
  toolId: ToolId;
};

/** Represents biological sex */
export enum Sex {
  Female = 'FEMALE',
  Intersex = 'INTERSEX',
  Male = 'MALE',
  Unspecified = 'UNSPECIFIED'
}

export type ShareableImage = {
  __typename?: 'ShareableImage';
  mediaUrl: Scalars['String']['output'];
};

export type ShareableMedia = {
  __typename?: 'ShareableMedia';
  /** The actual item (image, video, etc) to share */
  item: ShareableMediaItem;
  /** The default string that the user will use as 'subject' if they choose to share through email */
  subject?: Maybe<Scalars['String']['output']>;
  /** The default string that the user will share in social media together with whatever media item they're sharing */
  text?: Maybe<Scalars['String']['output']>;
  /** The type of the template that generated this shareable, so that we can send events to analytics */
  type: Scalars['String']['output'];
};

export type ShareableMediaItem = ShareableImage | ShareableToggleImage | ShareableVideo;

export type ShareableToggleImage = {
  __typename?: 'ShareableToggleImage';
  mediaUrl1: Scalars['String']['output'];
  mediaUrl2: Scalars['String']['output'];
  toggleButtonTitle1: Scalars['String']['output'];
  toggleButtonTitle2: Scalars['String']['output'];
};

export type ShareableVideo = {
  __typename?: 'ShareableVideo';
  mediaUrl: Scalars['String']['output'];
};

export type SideEffect = {
  __typename?: 'SideEffect';
  ctaDeepLink: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  sideEffectId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type SideEffectsSection = {
  __typename?: 'SideEffectsSection';
  ctaDeepLink: Scalars['String']['output'];
  ctaTitle: Scalars['String']['output'];
  footer: Scalars['String']['output'];
  sideEffects: Array<SideEffect>;
  title: Scalars['String']['output'];
};

/** Content for an small ad in the hamburger menu. */
export type SideNavMenuSmallContent = {
  __typename?: 'SideNavMenuSmallContent';
  /** The text of the CTA button. */
  buttonText: Scalars['String']['output'];
  /** The url of the image to show. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The url that should be opened when the ad is tapped. */
  targetUrl: Scalars['String']['output'];
  /** The title of this content. */
  title?: Maybe<Scalars['String']['output']>;
};

export type SimpleMealItem = {
  __typename?: 'SimpleMealItem';
  calories?: Maybe<Scalars['Float']['output']>;
  foodColor?: Maybe<FoodColor>;
  greenScore?: Maybe<Scalars['Float']['output']>;
  loggedUuid: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  nutritionBreakdown?: Maybe<NutritionBreakdown>;
  originUuid?: Maybe<Scalars['UUID']['output']>;
  portion?: Maybe<Portion>;
};

/** Required fields for client to recommend a SmartDose */
export type SmartDose = {
  __typename?: 'SmartDose';
  /** The user's personalized dosage amount */
  dose: Scalars['Float']['output'];
  /** The units their personalized dosage is measured in */
  doseUnits: DoseUnits;
  /** The internal id of the drug they are prescribed */
  internalDrugId: Scalars['ID']['output'];
};

/** Defines the sorting implementation for a list */
export type Sort = {
  /** The key that the list will be sorted by. If not set, the backend will select a default sort key */
  sortKey?: InputMaybe<Scalars['String']['input']>;
  /** The order in which the results are returned */
  sortOrder?: SortOrder;
};

/** Defines the sorting order for a list */
export enum SortOrder {
  /** Ascending order. Ex: A->Z, 1->9 */
  Ascending = 'ASCENDING',
  /** Use the natural sorting order as defined by the backend */
  Default = 'DEFAULT',
  /** Descending order. Ex: Z->A, 9->1 */
  Descending = 'DESCENDING'
}

/** Standalone content (e.g. static articles) served by url */
export type StandaloneContent = {
  __typename?: 'StandaloneContent';
  /** Analytics properties filled on the backend and forwarded by the mobile client in the analytics events */
  analyticsProperties?: Maybe<Array<AnalyticsProperty>>;
  /** Url for audio version of the content */
  audioSourceUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the user has completed this content */
  completed?: Maybe<Scalars['Boolean']['output']>;
  /** Opaque payload for tracking content consumption state */
  contentConsumedPayload?: Maybe<Scalars['String']['output']>;
  /** Id for content analytics */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Url for standalone content */
  contentUrl: Scalars['String']['output'];
  /** Optional format of content - used with rewards toast */
  format?: Maybe<Scalars['String']['output']>;
  /** Image URL */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Optional label for the content (e.g. 'video', 'story', 'quiz') */
  label?: Maybe<Scalars['String']['output']>;
  /** ID of the recommendation from the Recommender system */
  recommendationId?: Maybe<Scalars['String']['output']>;
  /** Display title */
  title: Scalars['String']['output'];
};

/** Groups standalone content into titled sections */
export type StandaloneContentSection = {
  __typename?: 'StandaloneContentSection';
  /** Optional label for refresh timing or status (e.g. 'Next in 12h') */
  refreshLabel?: Maybe<Scalars['String']['output']>;
  /** List of standalone content in the section */
  standaloneContentList: Array<StandaloneContent>;
  /** Section Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Task List assignment for the Home screen Standalone Content section. */
export type StandaloneContentSectionAssignment = {
  __typename?: 'StandaloneContentSectionAssignment';
  /** Section with a list of standalone content. */
  section: StandaloneContentSection;
};

export type StepGoalMetadata = {
  __typename?: 'StepGoalMetadata';
  minStepCount?: Maybe<Scalars['Int']['output']>;
};

export type StepTarget = {
  minStepCount?: InputMaybe<Scalars['Int']['input']>;
};

export type StepsData = {
  __typename?: 'StepsData';
  measurementCivilDate?: Maybe<Scalars['LocalDate']['output']>;
  stepCount: Scalars['Int']['output'];
};

export type StepsDataInput = {
  measurementCivilDate: Scalars['LocalDate']['input'];
  stepCount: Scalars['Int']['input'];
};

export type Streak = {
  __typename?: 'Streak';
  /** The list of days with states representing the state history of this streak */
  dayHistory?: Maybe<Array<StreakDay>>;
};

export enum StreakDailyStatus {
  /** Indicates the streak was frozen */
  Frozen = 'FROZEN',
  /** Indicates that the streak was increased */
  Incremented = 'INCREMENTED',
  /** Indicates that the streak was not increased or frozen */
  Missed = 'MISSED',
  /** Indicates that the day is still in progress */
  Pending = 'PENDING'
}

export type StreakDay = {
  __typename?: 'StreakDay';
  /** The date of the StreakDay state */
  date: Scalars['LocalDate']['output'];
  /** The length of the streak on the current day */
  length: Scalars['Int']['output'];
  /** The status for the given date */
  status: StreakDailyStatus;
};

export type StreakFreeze = {
  __typename?: 'StreakFreeze';
  /** The number of streak freezes available */
  count: Scalars['Int']['output'];
};

/**
 * Reason for the streak increase.
 * Used on clients to display different Welli animations and for analytics.
 */
export enum StreakIncreaseReason {
  /** User banked steps */
  StepBanking = 'STEP_BANKING'
}

export type StreakIncreasedCelebration = {
  __typename?: 'StreakIncreasedCelebration';
  /** The streak data for the last 7 days, today inclusive */
  history?: Maybe<Array<StreakDay>>;
  /** Optional configuration for the intro experience */
  intro?: Maybe<StreakIncreasedIntroExperience>;
  /** Reason for the streak increase. */
  reason?: Maybe<StreakIncreaseReason>;
  /** The current value of the streak */
  streakAmount: Scalars['Int']['output'];
  /** The type of the streak */
  streakType: StreakType;
};

export type StreakIncreasedIntroExperience = {
  __typename?: 'StreakIncreasedIntroExperience';
  /** List of possible commitment lengths in days */
  commitmentLengths?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Union of streaks specific processing results */
export type StreakProcessingResult = GamificationActionStreakFailure | GamificationActionStreakUpdated;

export enum StreakType {
  EngagementActionStreak = 'ENGAGEMENT_ACTION_STREAK'
}

/** Input for submitting a customer satisfaction survey */
export type SubmitCsatSurveyInput = {
  rating: Scalars['Int']['input'];
  submittedBy: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
  textFeedback?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Returns new state of an aggregated measurement on subscription and on any change detected by measurements-api.
   * fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   * future measurements) are unbounded. Limit corresponds to pageSize, but we aren't enabling full pagination over
   * subscriptions yet. Most use-cases should provide a fromCivilDateTime with reasonable scope, a toCivilDateTime
   * of the present, and keep expected measurement count in the low-hundreds, well short of the max limit of 1000.
   * If you need more than 1000 data points at once, reach out to TNG to make pagination available externally!
   */
  aggregatedMeasurementDataList: AggregatedMeasurementDataList;
  /**
   * Returns the information needed by the client to draw a chart with the specified measurements and annotations.
   * - fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   *     future measurements) are unbounded
   * - Chronological or reverse chronological order is provided by the "from" and "to" dates: if "from" is earlier than "to",
   *     then it will be in chronological order; and if "to" is earlier than "from", it will go in reverse chronological order
   * - You can also optionally limit by a maximum number of measurements and/or maximum number of annotations. Whatever
   *     is reached earlier will set the limit of the graph, and no further measurements or annotations beyond those
   *     will be provided (e.g. if we limit to 10 annotations, and the 10th annotation happens on a certain date, then no
   *     annotations or measurements will be provided beyond that date, even if we still had a larger limit of
   *     measurements). If not provided, they are each limited to 100. The maximum limit accepted is 500: if a higher
   *     limit is provided, it will be ignored and 500 will be used. We still don't provide any mechanism for pagination,
   *     so if you need more elements than that, please reach out to the Program Content team!
   */
  annotatedMeasurementTrendChart: AnnotatedMeasurementTrendChart;
  /**
   * DEPRECATED (use bloodGlucoseOverviewDataV2 instead) Provides an overview of a user's blood
   * glucose data for a specified time period, starting from a given date and extending backward
   * to cover the defined period. For example, if the specified period is 'WEEK' and the date is
   * '2025-01-01', the overview data will cover the period from '2024-12-26' to '2025-01-01'
   */
  bloodGlucoseOverviewData: BloodGlucoseOverviewData;
  /**
   * Provides an overview of a user's blood glucose data for a specified time period, starting
   * from a given date and extending backward to cover the defined period. For example, if the
   * specified period is 'WEEK' and the date is '2025-01-01', the overview data will cover the
   * period from '2024-12-26' to '2025-01-01'.
   *
   * Deprecates bloodGlucoseOverviewData: Users with 1k+ blood glucose logs in a week/month
   * (mainly CGM users) may see incomplete chart data due to a 1k cap in the backend aggregation
   * logic. Fixing it requires backend and client breaking changes, so a new version of the endpoint
   * is necessary.
   */
  bloodGlucoseOverviewDataV2: BloodGlucoseOverviewData;
  /** Returns any changes to the user's current body scan status */
  bodyScanTrackerState: BodyScanTrackerState;
  /**
   * Returns events when users earn rewards currency.
   * This triggers UI on the client to notify the user of the currency earned.
   */
  currencyEarned: CurrencyEarnedEvent;
  /** Placeholder field */
  empty?: Maybe<Scalars['ID']['output']>;
  /** Returns state of the home screen carousel */
  homeScreenCarouselState: HomeScreenCarouselState;
  /**
   * Returns new state of a given measurement on new subscription and on any change detected by measurements-api.
   * fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   * future measurements) are unbounded. Limit corresponds to pageSize, but we aren't enabling full pagination over
   * subscriptions yet. Most use-cases should provide a fromCivilDateTime with reasonable scope, a toCivilDateTime
   * of the present, and keep expected measurement count in the low-hundreds, well short of the max limit of 1000.
   * If you need more than 1000 data points at once, reach out to TNG to make pagination available externally!
   */
  measurementDataList: MeasurementDataList;
  /** Returns a list of past medication doses. */
  pastMedicationDoseList: PastMedicationDoseList;
  /**
   * Used to preview the result of processing a gamification action - this will not make any updates to the state of the system.
   * It will immediately emit a value, and if the state of the system changes, a new result will be emitted to ensure clients always have the live state.
   */
  previewGamificationAction: GamificationActionResult;
  /** Listen for processing updates of the scanId */
  processingState: FaceScanImageProcessingState;
  /**
   * Returns any changes to the user's rewards state.
   * This triggers a display update on the client to reflect the new rewards amount.
   */
  rewardsState: RewardsState;
  /** Returns the state of the streak for the currentDate */
  streakState?: Maybe<StreakDay>;
  /** Returns new state of SuccessKit on new subscription and on any change detected by tools-api */
  successKit: SuccessKit;
  /** Returns new state of tasks on subscription and on any change detected by task generators */
  taskList: TaskList;
  /** Returns successfully if x-noom-config-ref, x-noom-routing-id, and Accept-Language are successfully proxied */
  testHeaderProxying?: Maybe<Scalars['String']['output']>;
  /** Returns the message from TestMessageForGraphqlTriggeredProto every time it's fired for the specified access code */
  testSubscription: Scalars['String']['output'];
  /** Successfully returns three times before failing with an unauthorized API response */
  testUnauthorizedDuringConnection?: Maybe<Scalars['String']['output']>;
  /** Returns new state of tools on new subscription and on any change detected by tools-api */
  toolList: ToolList;
  /** Returns a list of upcoming medication doses. */
  upcomingMedicationDoseList: UpcomingMedicationDoseList;
};


export type SubscriptionAggregatedMeasurementDataListArgs = {
  accessCode: Scalars['String']['input'];
  ascendingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  datapointAggregation: MeasurementAggregationGrouping;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measurementType: MeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type SubscriptionAnnotatedMeasurementTrendChartArgs = {
  accessCode: Scalars['String']['input'];
  annotationType?: InputMaybe<TrendChartAnnotationType>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limitAnnotations?: InputMaybe<Scalars['Int']['input']>;
  limitMeasurements?: InputMaybe<Scalars['Int']['input']>;
  measurementType: TrendChartMeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type SubscriptionBloodGlucoseOverviewDataArgs = {
  accessCode: Scalars['String']['input'];
  period: BloodGlucoseOverviewPeriod;
  periodEndDate: Scalars['LocalDate']['input'];
};


export type SubscriptionBloodGlucoseOverviewDataV2Args = {
  accessCode: Scalars['String']['input'];
  period: BloodGlucoseOverviewPeriod;
  periodEndDate: Scalars['LocalDate']['input'];
};


export type SubscriptionBodyScanTrackerStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionCurrencyEarnedArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionHomeScreenCarouselStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionMeasurementDataListArgs = {
  accessCode: Scalars['String']['input'];
  ascendingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measurementType: MeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type SubscriptionPastMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type SubscriptionPreviewGamificationActionArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  data: GamificationActionDataInput;
};


export type SubscriptionProcessingStateArgs = {
  scanId: Scalars['UUID']['input'];
};


export type SubscriptionRewardsStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionStreakStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  type: StreakType;
  userCurrentDate: Scalars['LocalDate']['input'];
};


export type SubscriptionSuccessKitArgs = {
  accessCode: Scalars['String']['input'];
  programUuid: Scalars['UUID']['input'];
};


export type SubscriptionTaskListArgs = {
  accessCode: Scalars['String']['input'];
  taskListInput?: InputMaybe<TaskListSubscriptionInput>;
};


export type SubscriptionTestSubscriptionArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionToolListArgs = {
  accessCode: Scalars['String']['input'];
  programUuid: Scalars['UUID']['input'];
};


export type SubscriptionUpcomingMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
  programUuid: Scalars['String']['input'];
};

/** Specifies the user subscription tier - FREE or PAID */
export enum SubscriptionTier {
  Free = 'FREE',
  Paid = 'PAID'
}

/** Contains the information to present the SuccessKit in the UI */
export type SuccessKit = {
  __typename?: 'SuccessKit';
  /** List of Sections sorted in order to be displayed */
  sections: Array<SuccessKitSection>;
};

export type SuccessKitArticle = SuccessKitSectionItem & {
  __typename?: 'SuccessKitArticle';
  /** Analytics tag tracked when Article item is clicked */
  analyticsTag?: Maybe<Scalars['String']['output']>;
  /** Article URL to be opened in the Web view */
  contentUrl?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  subhead?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SuccessKitMetadata = {
  __typename?: 'SuccessKitMetadata';
  imageUrl?: Maybe<Scalars['String']['output']>;
  subheader?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SuccessKitSection = {
  __typename?: 'SuccessKitSection';
  /** Section ID */
  id: Scalars['String']['output'];
  /** Section items of various types, sorted in order to be displayed */
  sectionItems: Array<SuccessKitSectionItem>;
  /** Subtitle for the Section on the UI */
  subhead?: Maybe<Scalars['String']['output']>;
  /** Title for the Section on the UI */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * DEPRECATED in favor of sectionItems
   * @deprecated Use `sectionItems` instead.
   */
  tools: Array<SuccessKitTool>;
};

export type SuccessKitSectionItem = {
  /** URL of the thumbnail image displayed as part of the item's UI */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Subtitle for the item on the UI */
  subhead?: Maybe<Scalars['String']['output']>;
  /** Title for the item on the UI */
  title?: Maybe<Scalars['String']['output']>;
};

export type SuccessKitTool = SuccessKitSectionItem & {
  __typename?: 'SuccessKitTool';
  /**
   * DEPRECATED Used only in legacy clients for Article Tools, no longer needed.
   * @deprecated Here for legacy clients, no longer needed.
   */
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** Tool ID */
  id: ToolId;
  imageUrl?: Maybe<Scalars['String']['output']>;
  subhead?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SupportChatUnreadMessages = {
  __typename?: 'SupportChatUnreadMessages';
  /** Number of unread messages count with support chat */
  unreadMessagesCount: Scalars['Int']['output'];
};

export enum TargetPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Task = {
  __typename?: 'Task';
  assignment?: Maybe<Assignment>;
  programUuid?: Maybe<Scalars['UUID']['output']>;
  taskCompletedEventMetadata?: Maybe<Scalars['String']['output']>;
};

export type TaskList = {
  __typename?: 'TaskList';
  additionalMetadata?: Maybe<ClientHints>;
  tasks: Array<Maybe<Task>>;
};

/**
 * Input parameters for the taskList subscription.
 *
 * These parameters are intended to replace the (now deprecated) clientDate and isForPast parameters.
 *   - selectedDate replaces clientDate. Both are LocalDates, but selectedDate is named to more accurately
 *     reflect that it depends on user selection.
 *   - isForPast is derived from (selectedDate < currentDateTime.date), and no longer needs to be set explicitly.
 */
export type TaskListSubscriptionInput = {
  /**
   * The current civil date and time on the user's device.
   * For debugging, this may also involve an offset to simulate the past or future
   */
  currentDateTime: Scalars['LocalDateTime']['input'];
  /** LocalDate that represents what day's tasks the user is requesting */
  selectedDate: Scalars['LocalDate']['input'];
};

export type Tool = {
  __typename?: 'Tool';
  awardsNoomcoin: Scalars['Boolean']['output'];
  contentUrl: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: ToolId;
  metadata?: Maybe<ToolMetadata>;
  pinned: Scalars['Boolean']['output'];
};

/**
 *  These values should be aligned with:
 *  - tool_configuration.proto (ToolConfigurationProto.Widget.Id)
 *  - tool_id_enum.proto (ToolIdEnumProto.Value)
 */
export enum ToolId {
  ActivityBrainDump = 'ACTIVITY_BRAIN_DUMP',
  ActivityCreatePositiveExperiences = 'ACTIVITY_CREATE_POSITIVE_EXPERIENCES',
  ActivityCreateSpace = 'ACTIVITY_CREATE_SPACE',
  ActivityDefuseThoughts = 'ACTIVITY_DEFUSE_THOUGHTS',
  ActivityFeelFeelings = 'ACTIVITY_FEEL_FEELINGS',
  ActivityFreeFeelings = 'ACTIVITY_FREE_FEELINGS',
  ActivityGametime = 'ACTIVITY_GAMETIME',
  ActivityGetGrounded = 'ACTIVITY_GET_GROUNDED',
  ActivityGratitudeRemix = 'ACTIVITY_GRATITUDE_REMIX',
  ActivityMove = 'ACTIVITY_MOVE',
  ActivityReframe = 'ACTIVITY_REFRAME',
  ActivityRideWaves = 'ACTIVITY_RIDE_WAVES',
  ActivitySelfCompassionBreak = 'ACTIVITY_SELF_COMPASSION_BREAK',
  ActivitySharpenToolkit = 'ACTIVITY_SHARPEN_TOOLKIT',
  ActivitySleep = 'ACTIVITY_SLEEP',
  ActivitySoothe = 'ACTIVITY_SOOTHE',
  ArticleConstipation = 'ARTICLE_CONSTIPATION',
  ArticleDiarrhea = 'ARTICLE_DIARRHEA',
  ArticleFatigue = 'ARTICLE_FATIGUE',
  ArticleHeadaches = 'ARTICLE_HEADACHES',
  ArticleHotFlashes = 'ARTICLE_HOT_FLASHES',
  ArticleIndigestion = 'ARTICLE_INDIGESTION',
  ArticleInjection = 'ARTICLE_INJECTION',
  ArticleMaintenanceHabits = 'ARTICLE_MAINTENANCE_HABITS',
  ArticleNausea = 'ARTICLE_NAUSEA',
  ArticleProteinGuide = 'ARTICLE_PROTEIN_GUIDE',
  ArticleScienceAm = 'ARTICLE_SCIENCE_AM',
  ArticleSleepCheatSheet = 'ARTICLE_SLEEP_CHEAT_SHEET',
  ArticleTaperingBestPractices = 'ARTICLE_TAPERING_BEST_PRACTICES',
  ArticleWorkoutsFitStrong = 'ARTICLE_WORKOUTS_FIT_STRONG',
  BloodGlucose = 'BLOOD_GLUCOSE',
  BloodGlucoseTracking = 'BLOOD_GLUCOSE_TRACKING',
  BloodPressure = 'BLOOD_PRESSURE',
  BodyScan = 'BODY_SCAN',
  BreathingExercises = 'BREATHING_EXERCISES',
  CreateSpace = 'CREATE_SPACE',
  DailySteps = 'DAILY_STEPS',
  FitnessWorkouts = 'FITNESS_WORKOUTS',
  FoodColorLookUp = 'FOOD_COLOR_LOOK_UP',
  GroceryPlanner = 'GROCERY_PLANNER',
  Lessons = 'LESSONS',
  LogMeals = 'LOG_MEALS',
  Medication = 'MEDICATION',
  Meditation = 'MEDITATION',
  Mood = 'MOOD',
  Move = 'MOVE',
  MuscleDefense = 'MUSCLE_DEFENSE',
  PremiumMealPlans = 'PREMIUM_MEAL_PLANS',
  RapidRelief = 'RAPID_RELIEF',
  Recipes = 'RECIPES',
  Reframe = 'REFRAME',
  RideTheWave = 'RIDE_THE_WAVE',
  SelfCare = 'SELF_CARE',
  Sleep = 'SLEEP',
  Stress = 'STRESS',
  VideoMeditation = 'VIDEO_MEDITATION',
  WaterLogging = 'WATER_LOGGING',
  WeighIn = 'WEIGH_IN',
  Zumba = 'ZUMBA'
}

export type ToolList = {
  __typename?: 'ToolList';
  tools: Array<Tool>;
};

export type ToolMetadata = {
  __typename?: 'ToolMetadata';
  successKitMetadata?: Maybe<SuccessKitMetadata>;
};

export type ToolStatePatch = {
  newAwardsNoomcoin?: InputMaybe<Scalars['Boolean']['input']>;
  newEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  newIsInSuccessKit?: InputMaybe<Scalars['Boolean']['input']>;
  newPinned?: InputMaybe<Scalars['Boolean']['input']>;
  toolId: ToolId;
};

export type TrackerAssignment = {
  __typename?: 'TrackerAssignment';
  enabledOn?: Maybe<Scalars['LocalDate']['output']>;
  multiDayAssignment?: Maybe<MultiDayAssignment>;
  payload?: Maybe<TrackerAssignmentPayload>;
  title: Scalars['String']['output'];
  titleCompleted?: Maybe<Scalars['String']['output']>;
  type: TrackerTypes;
};

export type TrackerAssignmentPayload = ActivityDefaultPayload | BloodGlucoseTrackerPayload | DailyStepsPayload | LogMealsTrackerPayload | MedicationPayload | MedicationTrackerPayload | WaterLoggingPayload;

export enum TrackerTypes {
  ActivityBrainDump = 'ACTIVITY_BRAIN_DUMP',
  ActivityCreatePositiveExperiences = 'ACTIVITY_CREATE_POSITIVE_EXPERIENCES',
  ActivityCreateSpace = 'ACTIVITY_CREATE_SPACE',
  ActivityDefuseThoughts = 'ACTIVITY_DEFUSE_THOUGHTS',
  ActivityFeelFeelings = 'ACTIVITY_FEEL_FEELINGS',
  ActivityFreeFeelings = 'ACTIVITY_FREE_FEELINGS',
  ActivityGametime = 'ACTIVITY_GAMETIME',
  ActivityGetGrounded = 'ACTIVITY_GET_GROUNDED',
  ActivityGratitudeRemix = 'ACTIVITY_GRATITUDE_REMIX',
  ActivityMove = 'ACTIVITY_MOVE',
  ActivityReframe = 'ACTIVITY_REFRAME',
  ActivityRideWaves = 'ACTIVITY_RIDE_WAVES',
  ActivitySelfCompassionBreak = 'ACTIVITY_SELF_COMPASSION_BREAK',
  ActivitySharpenToolkit = 'ACTIVITY_SHARPEN_TOOLKIT',
  ActivitySleep = 'ACTIVITY_SLEEP',
  ActivitySoothe = 'ACTIVITY_SOOTHE',
  BloodGlucose = 'BLOOD_GLUCOSE',
  /**
   *  Used to implement the new "Blood Glucose Tracker" tool.
   *  See TechDoc https://docs.google.com/document/d/1mLjt1JYdjBeAY3aN7jSjH4O9pEv3zCsJFnVeYAls1rQ/edit?usp=sharing.
   */
  BloodGlucoseTracker = 'BLOOD_GLUCOSE_TRACKER',
  BloodPressure = 'BLOOD_PRESSURE',
  BodyScan = 'BODY_SCAN',
  DailySteps = 'DAILY_STEPS',
  LogMeals = 'LOG_MEALS',
  Medication = 'MEDICATION',
  /**
   *  Used to implement the new "Med Tracker" tool.
   *  See TechDoc https://docs.google.com/document/d/1wNlCuGib9WphyjZKDxrUgIr-VA_wzdK9Syzllh-vS20/edit.
   */
  MedicationTracker = 'MEDICATION_TRACKER',
  Mood = 'MOOD',
  Sleep = 'SLEEP',
  Stress = 'STRESS',
  WaterLogging = 'WATER_LOGGING',
  WeighIn = 'WEIGH_IN'
}

/** URL tracking parameters */
export type TrackingParams = {
  /** Buyflow features enabled by parameter */
  feature: Array<Scalars['String']['input']>;
  /** Initial URL */
  initialUrl?: InputMaybe<Scalars['String']['input']>;
  /** Referrer string */
  referrer?: InputMaybe<Scalars['String']['input']>;
  /** The campaign of the link */
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  /** What was clicked */
  utmContent?: InputMaybe<Scalars['String']['input']>;
  /** What medium the link came from */
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  /** Identifies which site sent the traffic */
  utmSource?: InputMaybe<Scalars['String']['input']>;
  /** Search terms related to the link */
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type TrendChartAnnotation = {
  __typename?: 'TrendChartAnnotation';
  date: Scalars['LocalDate']['output'];
  style: MeasurementSnapshotStyle;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** All supported annotations */
export enum TrendChartAnnotationType {
  Medication = 'MEDICATION'
}

export type TrendChartEntry = TrendChartAnnotation | TrendChartMeasurement;

export type TrendChartMeasurement = {
  __typename?: 'TrendChartMeasurement';
  date: Scalars['LocalDate']['output'];
  value: Scalars['Float']['output'];
};

/** All supported measurements */
export enum TrendChartMeasurementType {
  Weight = 'WEIGHT'
}

export type TriggerFaceScanResponse = {
  __typename?: 'TriggerFaceScanResponse';
  scanId?: Maybe<Scalars['UUID']['output']>;
};

/** These values should be aligned with ufc types from noom-contracts/coaching/CoachUfcTypeEnumProto */
export enum UfcType {
  Careteam = 'CARETEAM',
  Clinician = 'CLINICIAN',
  CoachOnDemand = 'COACH_ON_DEMAND',
  Guide = 'GUIDE',
  MhtClinician = 'MHT_CLINICIAN',
  Nmc = 'NMC',
  Premium = 'PREMIUM',
  SeniorNmc = 'SENIOR_NMC',
  Unknown = 'UNKNOWN'
}

/** User is not enrolled in rewards program, e.g. before earning the first Noomcoin. */
export type UnenrolledRewardsState = {
  __typename?: 'UnenrolledRewardsState';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

export type UpcomingMedicationDose = {
  __typename?: 'UpcomingMedicationDose';
  /** Date the dose should be taken on */
  dueDate: Scalars['LocalDate']['output'];
  /** Medication info: external_id, name, image_url */
  medication: MedicationInfo;
};

/**  Upcoming medication doses that user should take */
export type UpcomingMedicationDoseList = {
  __typename?: 'UpcomingMedicationDoseList';
  /** Metadata for fetching the next page of upcoming doses, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** List of upcoming doses */
  upcomingDoses: Array<UpcomingMedicationDose>;
};

export type UpdateInterstitialInput = {
  communityHint?: InputMaybe<Scalars['LocalDate']['input']>;
  communityIntroAnnouncement?: InputMaybe<Scalars['LocalDate']['input']>;
  successKitIntro?: InputMaybe<Scalars['LocalDate']['input']>;
};

/** Union type for different upsell ad content types. */
export type UpsellAdContent = HomeLargeContent | HomeScreenCarouselTileContent | NavigationButtonContent | SideNavMenuSmallContent | WeightGraphContent;

/** Payload for a location's ad placement. */
export type UpsellAdData = {
  __typename?: 'UpsellAdData';
  /** The content of the upsell ad. */
  content?: Maybe<UpsellAdContent>;
  upsellAdIdentifier: Scalars['String']['output'];
  upsellAdLocation: UpsellAdLocation;
  upsellAdType: UpsellAdType;
};

export type UpsellAdDataList = {
  __typename?: 'UpsellAdDataList';
  upsellAdData: Array<UpsellAdData>;
};

export enum UpsellAdLocation {
  /** Large Ad placement in Body Scan */
  BodyscanLarge = 'BODYSCAN_LARGE',
  /** Small Ad placement in Body Scan */
  BodyscanSmall = 'BODYSCAN_SMALL',
  /** Ad placement in chat lobby */
  ChatLobby = 'CHAT_LOBBY',
  /** Ad that can be present in the coach chat (mostly at the top) */
  CoachChat = 'COACH_CHAT',
  /** Ad that can be present on the coach's profile page. */
  CoachProfilePage = 'COACH_PROFILE_PAGE',
  /** Ad placement in FitOn */
  Fiton = 'FITON',
  /** Ad placement in the hamburger menu */
  Hamburger = 'HAMBURGER',
  /** Ad placement for home screen carousel */
  HomeCarousel = 'HOME_CAROUSEL',
  /** Large Ad placement in Home */
  HomeLarge = 'HOME_LARGE',
  /** Ad placement in the meal feedback screen. */
  MealFeedback = 'MEAL_FEEDBACK',
  /** No known location. */
  None = 'NONE',
  /** Ad placement with a button in the topnav */
  TopnavButton = 'TOPNAV_BUTTON',
  /** Default status for enums. */
  Uknown = 'UKNOWN',
  /** Ad placement in weight graph (after weigh in is recorded) */
  WeightGraph = 'WEIGHT_GRAPH'
}

/** Content for an ad testimonial. */
export type UpsellAdTestimonial = {
  __typename?: 'UpsellAdTestimonial';
  /** The author to attribute the testimonial to. */
  author?: Maybe<Scalars['String']['output']>;
  /** The url of the image to show. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The text of the testimony. */
  testimony?: Maybe<Scalars['String']['output']>;
  /** The amount of weight lost. */
  weightLostInKg?: Maybe<Scalars['Int']['output']>;
};

export enum UpsellAdType {
  /** Used for ads to purchase the baseline Healthy Weight program */
  HealthyWeight = 'HEALTHY_WEIGHT',
  /** Used for advertising ads to purchase med */
  Med = 'MED',
  /** No upsell ad id. */
  None = 'NONE',
  /** Used for advertising ads to purchase premium */
  Premium = 'PREMIUM',
  /** Used for advertising ads to purchase premium plus is user is eligible for premium plus */
  PremiumPlus = 'PREMIUM_PLUS',
  /** Default status for enums. */
  Uknown = 'UKNOWN'
}

/** Enumerates the policies that must be consented to */
export type UserConsentCheck = {
  __typename?: 'UserConsentCheck';
  /** Will be null if user consents are up-to-date */
  prompt?: Maybe<UserConsentInterstitial>;
  /** Will be empty if consents are up-to-date */
  requiredConsents: Array<Policy>;
};

/** Backend-driven content for home screen interstitial */
export type UserConsentInterstitial = {
  __typename?: 'UserConsentInterstitial';
  /** Markdown-formatted string containing links to the relevant policies */
  body: Scalars['String']['output'];
  positiveButtonText: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type UserGoal = {
  __typename?: 'UserGoal';
  enabled: Scalars['Boolean']['output'];
  goalId: GoalId;
  metadata?: Maybe<GoalMetadata>;
  userGoalId: Scalars['String']['output'];
};

export type UserGoalList = {
  __typename?: 'UserGoalList';
  userGoalList: Array<UserGoal>;
};

export type UserGoalPatch = {
  /** The source of user steps goal upsert action. If empty, then the action source will be empty in noom events */
  actionSource?: InputMaybe<UserGoalUpsertActionSource>;
  /** If true, then enable the tool; if false, then disable it. If empty, the enablement of the tool won't be affected */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new value that the goal target should have. If empty, then the target won't be affected */
  target?: InputMaybe<GoalTarget>;
};

/**
 *  These values should be aligned with:
 *  - shared.proto (GoalsEnumsProto.UserGoalUpsertActionSourceEnumProto.ActionSource)
 */
export enum UserGoalUpsertActionSource {
  Automated = 'AUTOMATED',
  Default = 'DEFAULT',
  Manual = 'MANUAL',
  Unknown = 'UNKNOWN'
}

export type UserModelSegment = {
  __typename?: 'UserModelSegment';
  /** User who created the segment */
  creator: Scalars['String']['output'];
  /** Segment's description */
  description?: Maybe<Scalars['String']['output']>;
  /** Segment ID */
  id: Scalars['ID']['output'];
  /** Whether the segment has been archived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the segment is locked for editing */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Segment name */
  name: Scalars['String']['output'];
  /** Server time created */
  serverTimeCreated?: Maybe<Scalars['LocalDateTime']['output']>;
  /** Server time updated */
  serverTimeUpdated?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type UserModelSegments = {
  __typename?: 'UserModelSegments';
  segments: Array<UserModelSegment>;
};

/**  A record of the user's decision for a given policy */
export type UserPolicyOption = {
  __typename?: 'UserPolicyOption';
  accessCode: Scalars['String']['output'];
  /**  The specific policy the user acted upon */
  policy: Policy;
  /**  The user's response for the policy */
  status: PolicyOptionStatus;
};

export type ValidicAttributionDataInput = {
  /** Identifier of the device. */
  sourceIdentifier: Scalars['String']['input'];
  /** Human-readable name of the source. */
  sourceName: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type ValidicV2AttributionDataInput = {
  /** Identifier of the device. */
  sourceIdentifier: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type WaterData = {
  __typename?: 'WaterData';
  measurementCivilDate: Scalars['LocalDate']['output'];
  waterInLiters: Scalars['Float']['output'];
};

export type WaterDataInput = {
  measurementCivilDate: Scalars['LocalDate']['input'];
  waterInLiters: Scalars['Float']['input'];
};

export type WaterGoalMetadata = {
  __typename?: 'WaterGoalMetadata';
  minWaterInLiters?: Maybe<Scalars['Float']['output']>;
};

export type WaterLoggingPayload = {
  __typename?: 'WaterLoggingPayload';
  targetInLiters: Scalars['Float']['output'];
};

export type WaterTarget = {
  minWaterInLiters?: InputMaybe<Scalars['Float']['input']>;
};

export type WeightData = {
  __typename?: 'WeightData';
  loggedInSignupFlow?: Maybe<Scalars['Boolean']['output']>;
  measurementCivilDate: Scalars['LocalDate']['output'];
  weightInKg: Scalars['Float']['output'];
};

export type WeightDataInput = {
  loggedInSignupFlow?: InputMaybe<Scalars['Boolean']['input']>;
  measurementCivilDate: Scalars['LocalDate']['input'];
  weightInKg: Scalars['Float']['input'];
};

/** Content for the bottom screen in weight graph flow. */
export type WeightGraphBottomScreen = {
  __typename?: 'WeightGraphBottomScreen';
  /** Primary button to respond to the bottom screen. */
  buttonFirst?: Maybe<Button>;
  /** Optional second button for the bottom screen. */
  buttonSecond?: Maybe<Button>;
  /** Text to display on the bottom screen. */
  text?: Maybe<Scalars['String']['output']>;
  /** Title of the bottom screen. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Content for an ad that appears after the user logs a weigh in. */
export type WeightGraphContent = {
  __typename?: 'WeightGraphContent';
  /** The initial screen to show to the user. */
  initialScreenId: Scalars['String']['output'];
  /** A list of screens that can be navigated by the user. */
  screens: Array<WeightGraphContentScreen>;
};

/** A screen in the weight graph content flow. */
export type WeightGraphContentScreen = {
  __typename?: 'WeightGraphContentScreen';
  /** The content of this screen. */
  content: WeightGraphContentScreenContent;
  /** Id for this screen. */
  screenId: Scalars['String']['output'];
};

/** Union type for different weight graph screen content types. */
export type WeightGraphContentScreenContent = WeightGraphBottomScreen | WeightGraphPlateauAd | WeightGraphResourcesScreen;

/** Content for the plateau ad in weight graph flow. */
export type WeightGraphPlateauAd = {
  __typename?: 'WeightGraphPlateauAd';
  /** Button on the bottom left of the plateau ad. */
  buttonLeft?: Maybe<Button>;
  /** Button on the bottom right of the plateau ad. */
  buttonRight?: Maybe<Button>;
  /** Heading to display on the plateau ad. */
  heading?: Maybe<Scalars['String']['output']>;
  /** URL of the image for the plateau ad. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Date we advertise the medication weight can be achieved on. */
  medWeightDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Weight we advertise the user can achieve with medication. */
  medWeightInKg?: Maybe<Scalars['Float']['output']>;
  /** Text to place on the plateau ad. */
  text?: Maybe<Scalars['String']['output']>;
  /** Title to place on the plateau ad. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Content for the resources screen in weight graph flow. */
export type WeightGraphResourcesScreen = {
  __typename?: 'WeightGraphResourcesScreen';
  /** List of plateau resources available. */
  resources: Array<PlateauResource>;
  /** Subtitle of the resources screen. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the resources screen. */
  title?: Maybe<Scalars['String']['output']>;
};

export type WeightMedsSnapshot = {
  __typename?: 'WeightMedsSnapshot';
  body?: Maybe<Scalars['String']['output']>;
  ctaTitle: Scalars['String']['output'];
  /** Encouragement text should be sent as markdown. Deep Links use supported. */
  encouragementMarkdown?: Maybe<Scalars['String']['output']>;
  graph: AnnotatedMeasurementTrendChart;
  headerAnimation: HeaderAnimation;
  sideEffectsSection?: Maybe<SideEffectsSection>;
  title: Scalars['String']['output'];
};

export type RecommendedBuyflowOffersQueryVariables = Exact<{
  input: RecommendedBuyflowOffersInput;
}>;


export type RecommendedBuyflowOffersQuery = { __typename?: 'Query', recommendedBuyflowOffers: { __typename?: 'RecommendedBuyflowOffersResponse', offers: Array<string>, recommendationId: string } };

export type SubmitConsentMutationVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  agreedToPolicies: Array<Policy> | Policy;
}>;


export type SubmitConsentMutation = { __typename?: 'Mutation', submitConsent?: boolean | null };


export const RecommendedBuyflowOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecommendedBuyflowOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecommendedBuyflowOffersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendedBuyflowOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"}},{"kind":"Field","name":{"kind":"Name","value":"recommendationId"}}]}}]}}]} as unknown as DocumentNode<RecommendedBuyflowOffersQuery, RecommendedBuyflowOffersQueryVariables>;
export const SubmitConsentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitConsent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreedToPolicies"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Policy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitConsent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"agreedToPolicies"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreedToPolicies"}}}]}]}}]} as unknown as DocumentNode<SubmitConsentMutation, SubmitConsentMutationVariables>;